// source: all.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.identity.Agreement', null, global);
goog.exportSymbol('proto.identity.BankCode', null, global);
goog.exportSymbol('proto.identity.Business', null, global);
goog.exportSymbol('proto.identity.BusinessInfo', null, global);
goog.exportSymbol('proto.identity.CountryISO3166', null, global);
goog.exportSymbol('proto.identity.DisburseEmailNotificationRequest', null, global);
goog.exportSymbol('proto.identity.Disbursement', null, global);
goog.exportSymbol('proto.identity.DisbursementDetail', null, global);
goog.exportSymbol('proto.identity.DomicileType', null, global);
goog.exportSymbol('proto.identity.EmailDisburseConfirmationRequest', null, global);
goog.exportSymbol('proto.identity.EmailDisburseConfirmationResponse', null, global);
goog.exportSymbol('proto.identity.EmailDownloadableStatementRequest', null, global);
goog.exportSymbol('proto.identity.EmailDownloadableStatementResponse', null, global);
goog.exportSymbol('proto.identity.EmailFDSEventAlertNotificationRequest', null, global);
goog.exportSymbol('proto.identity.EmailFDSEventAlertNotificationResponse', null, global);
goog.exportSymbol('proto.identity.EmailGenericNotificationRequest', null, global);
goog.exportSymbol('proto.identity.EmailGenericNotificationResponse', null, global);
goog.exportSymbol('proto.identity.EmailGroupNotificationResult', null, global);
goog.exportSymbol('proto.identity.EmailNotificationResult', null, global);
goog.exportSymbol('proto.identity.IDType', null, global);
goog.exportSymbol('proto.identity.Institution', null, global);
goog.exportSymbol('proto.identity.Intermediary', null, global);
goog.exportSymbol('proto.identity.KYCStatus', null, global);
goog.exportSymbol('proto.identity.KycPartner', null, global);
goog.exportSymbol('proto.identity.NotificationServiceChannel', null, global);
goog.exportSymbol('proto.identity.NotificationSetting', null, global);
goog.exportSymbol('proto.identity.NotificationSettingKey', null, global);
goog.exportSymbol('proto.identity.OrderBy', null, global);
goog.exportSymbol('proto.identity.Org', null, global);
goog.exportSymbol('proto.identity.OrgActivePeriod', null, global);
goog.exportSymbol('proto.identity.OrgType', null, global);
goog.exportSymbol('proto.identity.PICType', null, global);
goog.exportSymbol('proto.identity.PartnerKycStatus', null, global);
goog.exportSymbol('proto.identity.PermataKycStatus', null, global);
goog.exportSymbol('proto.identity.Permission', null, global);
goog.exportSymbol('proto.identity.PermissionSet', null, global);
goog.exportSymbol('proto.identity.Product', null, global);
goog.exportSymbol('proto.identity.ProductStatus', null, global);
goog.exportSymbol('proto.identity.ProductStatusRequest', null, global);
goog.exportSymbol('proto.identity.ProductStatusResponse', null, global);
goog.exportSymbol('proto.identity.Recipient', null, global);
goog.exportSymbol('proto.identity.ResourcePermissionSet', null, global);
goog.exportSymbol('proto.identity.Role', null, global);
goog.exportSymbol('proto.identity.SMSNotificationRequest', null, global);
goog.exportSymbol('proto.identity.SMSNotificationResponse', null, global);
goog.exportSymbol('proto.identity.SMSNotificationResult', null, global);
goog.exportSymbol('proto.identity.Status', null, global);
goog.exportSymbol('proto.identity.TutorialStepStatus', null, global);
goog.exportSymbol('proto.identity.TutorialSteps', null, global);
goog.exportSymbol('proto.identity.User', null, global);
goog.exportSymbol('proto.identity.UserRole', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.identity.Recipient = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.identity.Recipient, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.identity.Recipient.displayName = 'proto.identity.Recipient';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.identity.EmailNotificationResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.identity.EmailNotificationResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.identity.EmailNotificationResult.displayName = 'proto.identity.EmailNotificationResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.identity.EmailGroupNotificationResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.identity.EmailGroupNotificationResult.repeatedFields_, null);
};
goog.inherits(proto.identity.EmailGroupNotificationResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.identity.EmailGroupNotificationResult.displayName = 'proto.identity.EmailGroupNotificationResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.identity.SMSNotificationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.identity.SMSNotificationRequest.repeatedFields_, null);
};
goog.inherits(proto.identity.SMSNotificationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.identity.SMSNotificationRequest.displayName = 'proto.identity.SMSNotificationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.identity.SMSNotificationResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.identity.SMSNotificationResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.identity.SMSNotificationResult.displayName = 'proto.identity.SMSNotificationResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.identity.SMSNotificationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.identity.SMSNotificationResponse.repeatedFields_, null);
};
goog.inherits(proto.identity.SMSNotificationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.identity.SMSNotificationResponse.displayName = 'proto.identity.SMSNotificationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.identity.EmailGenericNotificationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.identity.EmailGenericNotificationRequest.repeatedFields_, null);
};
goog.inherits(proto.identity.EmailGenericNotificationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.identity.EmailGenericNotificationRequest.displayName = 'proto.identity.EmailGenericNotificationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.identity.EmailGenericNotificationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.identity.EmailGenericNotificationResponse.repeatedFields_, null);
};
goog.inherits(proto.identity.EmailGenericNotificationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.identity.EmailGenericNotificationResponse.displayName = 'proto.identity.EmailGenericNotificationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.identity.EmailDisburseConfirmationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.identity.EmailDisburseConfirmationRequest.repeatedFields_, null);
};
goog.inherits(proto.identity.EmailDisburseConfirmationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.identity.EmailDisburseConfirmationRequest.displayName = 'proto.identity.EmailDisburseConfirmationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.identity.DisbursementDetail = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.identity.DisbursementDetail, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.identity.DisbursementDetail.displayName = 'proto.identity.DisbursementDetail';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.identity.EmailDisburseConfirmationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.identity.EmailDisburseConfirmationResponse.repeatedFields_, null);
};
goog.inherits(proto.identity.EmailDisburseConfirmationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.identity.EmailDisburseConfirmationResponse.displayName = 'proto.identity.EmailDisburseConfirmationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.identity.DisburseEmailNotificationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.identity.DisburseEmailNotificationRequest.repeatedFields_, null);
};
goog.inherits(proto.identity.DisburseEmailNotificationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.identity.DisburseEmailNotificationRequest.displayName = 'proto.identity.DisburseEmailNotificationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.identity.Disbursement = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.identity.Disbursement, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.identity.Disbursement.displayName = 'proto.identity.Disbursement';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.identity.EmailDownloadableStatementRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.identity.EmailDownloadableStatementRequest.repeatedFields_, null);
};
goog.inherits(proto.identity.EmailDownloadableStatementRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.identity.EmailDownloadableStatementRequest.displayName = 'proto.identity.EmailDownloadableStatementRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.identity.EmailDownloadableStatementResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.identity.EmailDownloadableStatementResponse.repeatedFields_, null);
};
goog.inherits(proto.identity.EmailDownloadableStatementResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.identity.EmailDownloadableStatementResponse.displayName = 'proto.identity.EmailDownloadableStatementResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.identity.EmailFDSEventAlertNotificationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.identity.EmailFDSEventAlertNotificationRequest.repeatedFields_, null);
};
goog.inherits(proto.identity.EmailFDSEventAlertNotificationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.identity.EmailFDSEventAlertNotificationRequest.displayName = 'proto.identity.EmailFDSEventAlertNotificationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.identity.EmailFDSEventAlertNotificationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.identity.EmailFDSEventAlertNotificationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.identity.EmailFDSEventAlertNotificationResponse.displayName = 'proto.identity.EmailFDSEventAlertNotificationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.identity.User = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.identity.User, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.identity.User.displayName = 'proto.identity.User';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.identity.UserRole = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.identity.UserRole, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.identity.UserRole.displayName = 'proto.identity.UserRole';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.identity.Org = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.identity.Org, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.identity.Org.displayName = 'proto.identity.Org';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.identity.Business = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.identity.Business, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.identity.Business.displayName = 'proto.identity.Business';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.identity.BusinessInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.identity.BusinessInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.identity.BusinessInfo.displayName = 'proto.identity.BusinessInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.identity.Institution = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.identity.Institution, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.identity.Institution.displayName = 'proto.identity.Institution';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.identity.ProductStatusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.identity.ProductStatusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.identity.ProductStatusRequest.displayName = 'proto.identity.ProductStatusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.identity.ProductStatusResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.identity.ProductStatusResponse.repeatedFields_, null);
};
goog.inherits(proto.identity.ProductStatusResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.identity.ProductStatusResponse.displayName = 'proto.identity.ProductStatusResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.identity.ResourcePermissionSet = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.identity.ResourcePermissionSet, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.identity.ResourcePermissionSet.displayName = 'proto.identity.ResourcePermissionSet';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.identity.Permission = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.identity.Permission, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.identity.Permission.displayName = 'proto.identity.Permission';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.identity.Role = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.identity.Role.repeatedFields_, null);
};
goog.inherits(proto.identity.Role, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.identity.Role.displayName = 'proto.identity.Role';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.identity.NotificationSetting = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.identity.NotificationSetting.repeatedFields_, null);
};
goog.inherits(proto.identity.NotificationSetting, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.identity.NotificationSetting.displayName = 'proto.identity.NotificationSetting';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.identity.Intermediary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.identity.Intermediary.repeatedFields_, null);
};
goog.inherits(proto.identity.Intermediary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.identity.Intermediary.displayName = 'proto.identity.Intermediary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.identity.TutorialSteps = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.identity.TutorialSteps, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.identity.TutorialSteps.displayName = 'proto.identity.TutorialSteps';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.identity.Recipient.prototype.toObject = function(opt_includeInstance) {
  return proto.identity.Recipient.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.identity.Recipient} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.Recipient.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    phone: jspb.Message.getFieldWithDefault(msg, 2, ""),
    country: jspb.Message.getFieldWithDefault(msg, 3, ""),
    email: jspb.Message.getFieldWithDefault(msg, 4, ""),
    company: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.identity.Recipient}
 */
proto.identity.Recipient.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.identity.Recipient;
  return proto.identity.Recipient.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.identity.Recipient} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.identity.Recipient}
 */
proto.identity.Recipient.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhone(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompany(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.identity.Recipient.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.identity.Recipient.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.identity.Recipient} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.Recipient.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPhone();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCompany();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string Name = 1;
 * @return {string}
 */
proto.identity.Recipient.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Recipient} returns this
 */
proto.identity.Recipient.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Phone = 2;
 * @return {string}
 */
proto.identity.Recipient.prototype.getPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Recipient} returns this
 */
proto.identity.Recipient.prototype.setPhone = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Country = 3;
 * @return {string}
 */
proto.identity.Recipient.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Recipient} returns this
 */
proto.identity.Recipient.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string Email = 4;
 * @return {string}
 */
proto.identity.Recipient.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Recipient} returns this
 */
proto.identity.Recipient.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Company = 5;
 * @return {string}
 */
proto.identity.Recipient.prototype.getCompany = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Recipient} returns this
 */
proto.identity.Recipient.prototype.setCompany = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.identity.EmailNotificationResult.prototype.toObject = function(opt_includeInstance) {
  return proto.identity.EmailNotificationResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.identity.EmailNotificationResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.EmailNotificationResult.toObject = function(includeInstance, msg) {
  var f, obj = {
    recipient: (f = msg.getRecipient()) && proto.identity.Recipient.toObject(includeInstance, f),
    status: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.identity.EmailNotificationResult}
 */
proto.identity.EmailNotificationResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.identity.EmailNotificationResult;
  return proto.identity.EmailNotificationResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.identity.EmailNotificationResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.identity.EmailNotificationResult}
 */
proto.identity.EmailNotificationResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.identity.Recipient;
      reader.readMessage(value,proto.identity.Recipient.deserializeBinaryFromReader);
      msg.setRecipient(value);
      break;
    case 2:
      var value = /** @type {!proto.identity.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.identity.EmailNotificationResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.identity.EmailNotificationResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.identity.EmailNotificationResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.EmailNotificationResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRecipient();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.identity.Recipient.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional Recipient Recipient = 1;
 * @return {?proto.identity.Recipient}
 */
proto.identity.EmailNotificationResult.prototype.getRecipient = function() {
  return /** @type{?proto.identity.Recipient} */ (
    jspb.Message.getWrapperField(this, proto.identity.Recipient, 1));
};


/**
 * @param {?proto.identity.Recipient|undefined} value
 * @return {!proto.identity.EmailNotificationResult} returns this
*/
proto.identity.EmailNotificationResult.prototype.setRecipient = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.identity.EmailNotificationResult} returns this
 */
proto.identity.EmailNotificationResult.prototype.clearRecipient = function() {
  return this.setRecipient(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.identity.EmailNotificationResult.prototype.hasRecipient = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Status Status = 2;
 * @return {!proto.identity.Status}
 */
proto.identity.EmailNotificationResult.prototype.getStatus = function() {
  return /** @type {!proto.identity.Status} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.identity.Status} value
 * @return {!proto.identity.EmailNotificationResult} returns this
 */
proto.identity.EmailNotificationResult.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.identity.EmailGroupNotificationResult.repeatedFields_ = [1,2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.identity.EmailGroupNotificationResult.prototype.toObject = function(opt_includeInstance) {
  return proto.identity.EmailGroupNotificationResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.identity.EmailGroupNotificationResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.EmailGroupNotificationResult.toObject = function(includeInstance, msg) {
  var f, obj = {
    toList: jspb.Message.toObjectList(msg.getToList(),
    proto.identity.Recipient.toObject, includeInstance),
    ccList: jspb.Message.toObjectList(msg.getCcList(),
    proto.identity.Recipient.toObject, includeInstance),
    bccList: jspb.Message.toObjectList(msg.getBccList(),
    proto.identity.Recipient.toObject, includeInstance),
    status: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.identity.EmailGroupNotificationResult}
 */
proto.identity.EmailGroupNotificationResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.identity.EmailGroupNotificationResult;
  return proto.identity.EmailGroupNotificationResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.identity.EmailGroupNotificationResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.identity.EmailGroupNotificationResult}
 */
proto.identity.EmailGroupNotificationResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.identity.Recipient;
      reader.readMessage(value,proto.identity.Recipient.deserializeBinaryFromReader);
      msg.addTo(value);
      break;
    case 2:
      var value = new proto.identity.Recipient;
      reader.readMessage(value,proto.identity.Recipient.deserializeBinaryFromReader);
      msg.addCc(value);
      break;
    case 3:
      var value = new proto.identity.Recipient;
      reader.readMessage(value,proto.identity.Recipient.deserializeBinaryFromReader);
      msg.addBcc(value);
      break;
    case 4:
      var value = /** @type {!proto.identity.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.identity.EmailGroupNotificationResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.identity.EmailGroupNotificationResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.identity.EmailGroupNotificationResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.EmailGroupNotificationResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getToList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.identity.Recipient.serializeBinaryToWriter
    );
  }
  f = message.getCcList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.identity.Recipient.serializeBinaryToWriter
    );
  }
  f = message.getBccList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.identity.Recipient.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
};


/**
 * repeated Recipient To = 1;
 * @return {!Array<!proto.identity.Recipient>}
 */
proto.identity.EmailGroupNotificationResult.prototype.getToList = function() {
  return /** @type{!Array<!proto.identity.Recipient>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.identity.Recipient, 1));
};


/**
 * @param {!Array<!proto.identity.Recipient>} value
 * @return {!proto.identity.EmailGroupNotificationResult} returns this
*/
proto.identity.EmailGroupNotificationResult.prototype.setToList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.identity.Recipient=} opt_value
 * @param {number=} opt_index
 * @return {!proto.identity.Recipient}
 */
proto.identity.EmailGroupNotificationResult.prototype.addTo = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.identity.Recipient, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.identity.EmailGroupNotificationResult} returns this
 */
proto.identity.EmailGroupNotificationResult.prototype.clearToList = function() {
  return this.setToList([]);
};


/**
 * repeated Recipient Cc = 2;
 * @return {!Array<!proto.identity.Recipient>}
 */
proto.identity.EmailGroupNotificationResult.prototype.getCcList = function() {
  return /** @type{!Array<!proto.identity.Recipient>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.identity.Recipient, 2));
};


/**
 * @param {!Array<!proto.identity.Recipient>} value
 * @return {!proto.identity.EmailGroupNotificationResult} returns this
*/
proto.identity.EmailGroupNotificationResult.prototype.setCcList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.identity.Recipient=} opt_value
 * @param {number=} opt_index
 * @return {!proto.identity.Recipient}
 */
proto.identity.EmailGroupNotificationResult.prototype.addCc = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.identity.Recipient, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.identity.EmailGroupNotificationResult} returns this
 */
proto.identity.EmailGroupNotificationResult.prototype.clearCcList = function() {
  return this.setCcList([]);
};


/**
 * repeated Recipient Bcc = 3;
 * @return {!Array<!proto.identity.Recipient>}
 */
proto.identity.EmailGroupNotificationResult.prototype.getBccList = function() {
  return /** @type{!Array<!proto.identity.Recipient>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.identity.Recipient, 3));
};


/**
 * @param {!Array<!proto.identity.Recipient>} value
 * @return {!proto.identity.EmailGroupNotificationResult} returns this
*/
proto.identity.EmailGroupNotificationResult.prototype.setBccList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.identity.Recipient=} opt_value
 * @param {number=} opt_index
 * @return {!proto.identity.Recipient}
 */
proto.identity.EmailGroupNotificationResult.prototype.addBcc = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.identity.Recipient, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.identity.EmailGroupNotificationResult} returns this
 */
proto.identity.EmailGroupNotificationResult.prototype.clearBccList = function() {
  return this.setBccList([]);
};


/**
 * optional Status Status = 4;
 * @return {!proto.identity.Status}
 */
proto.identity.EmailGroupNotificationResult.prototype.getStatus = function() {
  return /** @type {!proto.identity.Status} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.identity.Status} value
 * @return {!proto.identity.EmailGroupNotificationResult} returns this
 */
proto.identity.EmailGroupNotificationResult.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.identity.SMSNotificationRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.identity.SMSNotificationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.identity.SMSNotificationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.identity.SMSNotificationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.SMSNotificationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    recipientsList: jspb.Message.toObjectList(msg.getRecipientsList(),
    proto.identity.Recipient.toObject, includeInstance),
    message: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.identity.SMSNotificationRequest}
 */
proto.identity.SMSNotificationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.identity.SMSNotificationRequest;
  return proto.identity.SMSNotificationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.identity.SMSNotificationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.identity.SMSNotificationRequest}
 */
proto.identity.SMSNotificationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.identity.Recipient;
      reader.readMessage(value,proto.identity.Recipient.deserializeBinaryFromReader);
      msg.addRecipients(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.identity.SMSNotificationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.identity.SMSNotificationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.identity.SMSNotificationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.SMSNotificationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRecipientsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.identity.Recipient.serializeBinaryToWriter
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * repeated Recipient Recipients = 1;
 * @return {!Array<!proto.identity.Recipient>}
 */
proto.identity.SMSNotificationRequest.prototype.getRecipientsList = function() {
  return /** @type{!Array<!proto.identity.Recipient>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.identity.Recipient, 1));
};


/**
 * @param {!Array<!proto.identity.Recipient>} value
 * @return {!proto.identity.SMSNotificationRequest} returns this
*/
proto.identity.SMSNotificationRequest.prototype.setRecipientsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.identity.Recipient=} opt_value
 * @param {number=} opt_index
 * @return {!proto.identity.Recipient}
 */
proto.identity.SMSNotificationRequest.prototype.addRecipients = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.identity.Recipient, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.identity.SMSNotificationRequest} returns this
 */
proto.identity.SMSNotificationRequest.prototype.clearRecipientsList = function() {
  return this.setRecipientsList([]);
};


/**
 * optional string Message = 2;
 * @return {string}
 */
proto.identity.SMSNotificationRequest.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.SMSNotificationRequest} returns this
 */
proto.identity.SMSNotificationRequest.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.identity.SMSNotificationResult.prototype.toObject = function(opt_includeInstance) {
  return proto.identity.SMSNotificationResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.identity.SMSNotificationResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.SMSNotificationResult.toObject = function(includeInstance, msg) {
  var f, obj = {
    recipient: (f = msg.getRecipient()) && proto.identity.Recipient.toObject(includeInstance, f),
    status: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.identity.SMSNotificationResult}
 */
proto.identity.SMSNotificationResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.identity.SMSNotificationResult;
  return proto.identity.SMSNotificationResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.identity.SMSNotificationResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.identity.SMSNotificationResult}
 */
proto.identity.SMSNotificationResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.identity.Recipient;
      reader.readMessage(value,proto.identity.Recipient.deserializeBinaryFromReader);
      msg.setRecipient(value);
      break;
    case 2:
      var value = /** @type {!proto.identity.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.identity.SMSNotificationResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.identity.SMSNotificationResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.identity.SMSNotificationResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.SMSNotificationResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRecipient();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.identity.Recipient.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional Recipient Recipient = 1;
 * @return {?proto.identity.Recipient}
 */
proto.identity.SMSNotificationResult.prototype.getRecipient = function() {
  return /** @type{?proto.identity.Recipient} */ (
    jspb.Message.getWrapperField(this, proto.identity.Recipient, 1));
};


/**
 * @param {?proto.identity.Recipient|undefined} value
 * @return {!proto.identity.SMSNotificationResult} returns this
*/
proto.identity.SMSNotificationResult.prototype.setRecipient = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.identity.SMSNotificationResult} returns this
 */
proto.identity.SMSNotificationResult.prototype.clearRecipient = function() {
  return this.setRecipient(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.identity.SMSNotificationResult.prototype.hasRecipient = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Status Status = 2;
 * @return {!proto.identity.Status}
 */
proto.identity.SMSNotificationResult.prototype.getStatus = function() {
  return /** @type {!proto.identity.Status} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.identity.Status} value
 * @return {!proto.identity.SMSNotificationResult} returns this
 */
proto.identity.SMSNotificationResult.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.identity.SMSNotificationResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.identity.SMSNotificationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.identity.SMSNotificationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.identity.SMSNotificationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.SMSNotificationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    resultsList: jspb.Message.toObjectList(msg.getResultsList(),
    proto.identity.SMSNotificationResult.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.identity.SMSNotificationResponse}
 */
proto.identity.SMSNotificationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.identity.SMSNotificationResponse;
  return proto.identity.SMSNotificationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.identity.SMSNotificationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.identity.SMSNotificationResponse}
 */
proto.identity.SMSNotificationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.identity.SMSNotificationResult;
      reader.readMessage(value,proto.identity.SMSNotificationResult.deserializeBinaryFromReader);
      msg.addResults(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.identity.SMSNotificationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.identity.SMSNotificationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.identity.SMSNotificationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.SMSNotificationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResultsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.identity.SMSNotificationResult.serializeBinaryToWriter
    );
  }
};


/**
 * repeated SMSNotificationResult Results = 1;
 * @return {!Array<!proto.identity.SMSNotificationResult>}
 */
proto.identity.SMSNotificationResponse.prototype.getResultsList = function() {
  return /** @type{!Array<!proto.identity.SMSNotificationResult>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.identity.SMSNotificationResult, 1));
};


/**
 * @param {!Array<!proto.identity.SMSNotificationResult>} value
 * @return {!proto.identity.SMSNotificationResponse} returns this
*/
proto.identity.SMSNotificationResponse.prototype.setResultsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.identity.SMSNotificationResult=} opt_value
 * @param {number=} opt_index
 * @return {!proto.identity.SMSNotificationResult}
 */
proto.identity.SMSNotificationResponse.prototype.addResults = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.identity.SMSNotificationResult, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.identity.SMSNotificationResponse} returns this
 */
proto.identity.SMSNotificationResponse.prototype.clearResultsList = function() {
  return this.setResultsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.identity.EmailGenericNotificationRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.identity.EmailGenericNotificationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.identity.EmailGenericNotificationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.identity.EmailGenericNotificationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.EmailGenericNotificationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    recipientsList: jspb.Message.toObjectList(msg.getRecipientsList(),
    proto.identity.Recipient.toObject, includeInstance),
    subject: jspb.Message.getFieldWithDefault(msg, 2, ""),
    message: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.identity.EmailGenericNotificationRequest}
 */
proto.identity.EmailGenericNotificationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.identity.EmailGenericNotificationRequest;
  return proto.identity.EmailGenericNotificationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.identity.EmailGenericNotificationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.identity.EmailGenericNotificationRequest}
 */
proto.identity.EmailGenericNotificationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.identity.Recipient;
      reader.readMessage(value,proto.identity.Recipient.deserializeBinaryFromReader);
      msg.addRecipients(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubject(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.identity.EmailGenericNotificationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.identity.EmailGenericNotificationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.identity.EmailGenericNotificationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.EmailGenericNotificationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRecipientsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.identity.Recipient.serializeBinaryToWriter
    );
  }
  f = message.getSubject();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * repeated Recipient Recipients = 1;
 * @return {!Array<!proto.identity.Recipient>}
 */
proto.identity.EmailGenericNotificationRequest.prototype.getRecipientsList = function() {
  return /** @type{!Array<!proto.identity.Recipient>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.identity.Recipient, 1));
};


/**
 * @param {!Array<!proto.identity.Recipient>} value
 * @return {!proto.identity.EmailGenericNotificationRequest} returns this
*/
proto.identity.EmailGenericNotificationRequest.prototype.setRecipientsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.identity.Recipient=} opt_value
 * @param {number=} opt_index
 * @return {!proto.identity.Recipient}
 */
proto.identity.EmailGenericNotificationRequest.prototype.addRecipients = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.identity.Recipient, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.identity.EmailGenericNotificationRequest} returns this
 */
proto.identity.EmailGenericNotificationRequest.prototype.clearRecipientsList = function() {
  return this.setRecipientsList([]);
};


/**
 * optional string Subject = 2;
 * @return {string}
 */
proto.identity.EmailGenericNotificationRequest.prototype.getSubject = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.EmailGenericNotificationRequest} returns this
 */
proto.identity.EmailGenericNotificationRequest.prototype.setSubject = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Message = 3;
 * @return {string}
 */
proto.identity.EmailGenericNotificationRequest.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.EmailGenericNotificationRequest} returns this
 */
proto.identity.EmailGenericNotificationRequest.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.identity.EmailGenericNotificationResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.identity.EmailGenericNotificationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.identity.EmailGenericNotificationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.identity.EmailGenericNotificationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.EmailGenericNotificationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    resultsList: jspb.Message.toObjectList(msg.getResultsList(),
    proto.identity.EmailNotificationResult.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.identity.EmailGenericNotificationResponse}
 */
proto.identity.EmailGenericNotificationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.identity.EmailGenericNotificationResponse;
  return proto.identity.EmailGenericNotificationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.identity.EmailGenericNotificationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.identity.EmailGenericNotificationResponse}
 */
proto.identity.EmailGenericNotificationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.identity.EmailNotificationResult;
      reader.readMessage(value,proto.identity.EmailNotificationResult.deserializeBinaryFromReader);
      msg.addResults(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.identity.EmailGenericNotificationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.identity.EmailGenericNotificationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.identity.EmailGenericNotificationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.EmailGenericNotificationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResultsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.identity.EmailNotificationResult.serializeBinaryToWriter
    );
  }
};


/**
 * repeated EmailNotificationResult Results = 1;
 * @return {!Array<!proto.identity.EmailNotificationResult>}
 */
proto.identity.EmailGenericNotificationResponse.prototype.getResultsList = function() {
  return /** @type{!Array<!proto.identity.EmailNotificationResult>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.identity.EmailNotificationResult, 1));
};


/**
 * @param {!Array<!proto.identity.EmailNotificationResult>} value
 * @return {!proto.identity.EmailGenericNotificationResponse} returns this
*/
proto.identity.EmailGenericNotificationResponse.prototype.setResultsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.identity.EmailNotificationResult=} opt_value
 * @param {number=} opt_index
 * @return {!proto.identity.EmailNotificationResult}
 */
proto.identity.EmailGenericNotificationResponse.prototype.addResults = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.identity.EmailNotificationResult, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.identity.EmailGenericNotificationResponse} returns this
 */
proto.identity.EmailGenericNotificationResponse.prototype.clearResultsList = function() {
  return this.setResultsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.identity.EmailDisburseConfirmationRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.identity.EmailDisburseConfirmationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.identity.EmailDisburseConfirmationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.identity.EmailDisburseConfirmationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.EmailDisburseConfirmationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    recipientsList: jspb.Message.toObjectList(msg.getRecipientsList(),
    proto.identity.Recipient.toObject, includeInstance),
    disbursementdetail: (f = msg.getDisbursementdetail()) && proto.identity.DisbursementDetail.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.identity.EmailDisburseConfirmationRequest}
 */
proto.identity.EmailDisburseConfirmationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.identity.EmailDisburseConfirmationRequest;
  return proto.identity.EmailDisburseConfirmationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.identity.EmailDisburseConfirmationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.identity.EmailDisburseConfirmationRequest}
 */
proto.identity.EmailDisburseConfirmationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.identity.Recipient;
      reader.readMessage(value,proto.identity.Recipient.deserializeBinaryFromReader);
      msg.addRecipients(value);
      break;
    case 2:
      var value = new proto.identity.DisbursementDetail;
      reader.readMessage(value,proto.identity.DisbursementDetail.deserializeBinaryFromReader);
      msg.setDisbursementdetail(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.identity.EmailDisburseConfirmationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.identity.EmailDisburseConfirmationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.identity.EmailDisburseConfirmationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.EmailDisburseConfirmationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRecipientsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.identity.Recipient.serializeBinaryToWriter
    );
  }
  f = message.getDisbursementdetail();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.identity.DisbursementDetail.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Recipient Recipients = 1;
 * @return {!Array<!proto.identity.Recipient>}
 */
proto.identity.EmailDisburseConfirmationRequest.prototype.getRecipientsList = function() {
  return /** @type{!Array<!proto.identity.Recipient>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.identity.Recipient, 1));
};


/**
 * @param {!Array<!proto.identity.Recipient>} value
 * @return {!proto.identity.EmailDisburseConfirmationRequest} returns this
*/
proto.identity.EmailDisburseConfirmationRequest.prototype.setRecipientsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.identity.Recipient=} opt_value
 * @param {number=} opt_index
 * @return {!proto.identity.Recipient}
 */
proto.identity.EmailDisburseConfirmationRequest.prototype.addRecipients = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.identity.Recipient, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.identity.EmailDisburseConfirmationRequest} returns this
 */
proto.identity.EmailDisburseConfirmationRequest.prototype.clearRecipientsList = function() {
  return this.setRecipientsList([]);
};


/**
 * optional DisbursementDetail DisbursementDetail = 2;
 * @return {?proto.identity.DisbursementDetail}
 */
proto.identity.EmailDisburseConfirmationRequest.prototype.getDisbursementdetail = function() {
  return /** @type{?proto.identity.DisbursementDetail} */ (
    jspb.Message.getWrapperField(this, proto.identity.DisbursementDetail, 2));
};


/**
 * @param {?proto.identity.DisbursementDetail|undefined} value
 * @return {!proto.identity.EmailDisburseConfirmationRequest} returns this
*/
proto.identity.EmailDisburseConfirmationRequest.prototype.setDisbursementdetail = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.identity.EmailDisburseConfirmationRequest} returns this
 */
proto.identity.EmailDisburseConfirmationRequest.prototype.clearDisbursementdetail = function() {
  return this.setDisbursementdetail(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.identity.EmailDisburseConfirmationRequest.prototype.hasDisbursementdetail = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.identity.DisbursementDetail.prototype.toObject = function(opt_includeInstance) {
  return proto.identity.DisbursementDetail.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.identity.DisbursementDetail} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.DisbursementDetail.toObject = function(includeInstance, msg) {
  var f, obj = {
    sourceaccountname: jspb.Message.getFieldWithDefault(msg, 1, ""),
    brankasreferenceid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    externalreferenceid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    transactiondate: jspb.Message.getFieldWithDefault(msg, 4, ""),
    destinationaccountbank: jspb.Message.getFieldWithDefault(msg, 5, ""),
    destinationaccountname: jspb.Message.getFieldWithDefault(msg, 6, ""),
    destinationaccountnumber: jspb.Message.getFieldWithDefault(msg, 7, ""),
    destinationamountcurrency: jspb.Message.getFieldWithDefault(msg, 8, ""),
    destinationamountvalue: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.identity.DisbursementDetail}
 */
proto.identity.DisbursementDetail.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.identity.DisbursementDetail;
  return proto.identity.DisbursementDetail.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.identity.DisbursementDetail} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.identity.DisbursementDetail}
 */
proto.identity.DisbursementDetail.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceaccountname(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrankasreferenceid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setExternalreferenceid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransactiondate(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDestinationaccountbank(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDestinationaccountname(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setDestinationaccountnumber(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setDestinationamountcurrency(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setDestinationamountvalue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.identity.DisbursementDetail.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.identity.DisbursementDetail.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.identity.DisbursementDetail} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.DisbursementDetail.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSourceaccountname();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBrankasreferenceid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getExternalreferenceid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTransactiondate();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDestinationaccountbank();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDestinationaccountname();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getDestinationaccountnumber();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getDestinationamountcurrency();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getDestinationamountvalue();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional string SourceAccountName = 1;
 * @return {string}
 */
proto.identity.DisbursementDetail.prototype.getSourceaccountname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.DisbursementDetail} returns this
 */
proto.identity.DisbursementDetail.prototype.setSourceaccountname = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string BrankasReferenceID = 2;
 * @return {string}
 */
proto.identity.DisbursementDetail.prototype.getBrankasreferenceid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.DisbursementDetail} returns this
 */
proto.identity.DisbursementDetail.prototype.setBrankasreferenceid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string ExternalReferenceID = 3;
 * @return {string}
 */
proto.identity.DisbursementDetail.prototype.getExternalreferenceid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.DisbursementDetail} returns this
 */
proto.identity.DisbursementDetail.prototype.setExternalreferenceid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string TransactionDate = 4;
 * @return {string}
 */
proto.identity.DisbursementDetail.prototype.getTransactiondate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.DisbursementDetail} returns this
 */
proto.identity.DisbursementDetail.prototype.setTransactiondate = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string DestinationAccountBank = 5;
 * @return {string}
 */
proto.identity.DisbursementDetail.prototype.getDestinationaccountbank = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.DisbursementDetail} returns this
 */
proto.identity.DisbursementDetail.prototype.setDestinationaccountbank = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string DestinationAccountName = 6;
 * @return {string}
 */
proto.identity.DisbursementDetail.prototype.getDestinationaccountname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.DisbursementDetail} returns this
 */
proto.identity.DisbursementDetail.prototype.setDestinationaccountname = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string DestinationAccountNumber = 7;
 * @return {string}
 */
proto.identity.DisbursementDetail.prototype.getDestinationaccountnumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.DisbursementDetail} returns this
 */
proto.identity.DisbursementDetail.prototype.setDestinationaccountnumber = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string DestinationAmountCurrency = 8;
 * @return {string}
 */
proto.identity.DisbursementDetail.prototype.getDestinationamountcurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.DisbursementDetail} returns this
 */
proto.identity.DisbursementDetail.prototype.setDestinationamountcurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string DestinationAmountValue = 9;
 * @return {string}
 */
proto.identity.DisbursementDetail.prototype.getDestinationamountvalue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.DisbursementDetail} returns this
 */
proto.identity.DisbursementDetail.prototype.setDestinationamountvalue = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.identity.EmailDisburseConfirmationResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.identity.EmailDisburseConfirmationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.identity.EmailDisburseConfirmationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.identity.EmailDisburseConfirmationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.EmailDisburseConfirmationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    resultsList: jspb.Message.toObjectList(msg.getResultsList(),
    proto.identity.EmailNotificationResult.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.identity.EmailDisburseConfirmationResponse}
 */
proto.identity.EmailDisburseConfirmationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.identity.EmailDisburseConfirmationResponse;
  return proto.identity.EmailDisburseConfirmationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.identity.EmailDisburseConfirmationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.identity.EmailDisburseConfirmationResponse}
 */
proto.identity.EmailDisburseConfirmationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.identity.EmailNotificationResult;
      reader.readMessage(value,proto.identity.EmailNotificationResult.deserializeBinaryFromReader);
      msg.addResults(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.identity.EmailDisburseConfirmationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.identity.EmailDisburseConfirmationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.identity.EmailDisburseConfirmationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.EmailDisburseConfirmationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResultsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.identity.EmailNotificationResult.serializeBinaryToWriter
    );
  }
};


/**
 * repeated EmailNotificationResult Results = 1;
 * @return {!Array<!proto.identity.EmailNotificationResult>}
 */
proto.identity.EmailDisburseConfirmationResponse.prototype.getResultsList = function() {
  return /** @type{!Array<!proto.identity.EmailNotificationResult>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.identity.EmailNotificationResult, 1));
};


/**
 * @param {!Array<!proto.identity.EmailNotificationResult>} value
 * @return {!proto.identity.EmailDisburseConfirmationResponse} returns this
*/
proto.identity.EmailDisburseConfirmationResponse.prototype.setResultsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.identity.EmailNotificationResult=} opt_value
 * @param {number=} opt_index
 * @return {!proto.identity.EmailNotificationResult}
 */
proto.identity.EmailDisburseConfirmationResponse.prototype.addResults = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.identity.EmailNotificationResult, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.identity.EmailDisburseConfirmationResponse} returns this
 */
proto.identity.EmailDisburseConfirmationResponse.prototype.clearResultsList = function() {
  return this.setResultsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.identity.DisburseEmailNotificationRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.identity.DisburseEmailNotificationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.identity.DisburseEmailNotificationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.identity.DisburseEmailNotificationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.DisburseEmailNotificationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    recipientsList: jspb.Message.toObjectList(msg.getRecipientsList(),
    proto.identity.Recipient.toObject, includeInstance),
    disbursement: (f = msg.getDisbursement()) && proto.identity.Disbursement.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.identity.DisburseEmailNotificationRequest}
 */
proto.identity.DisburseEmailNotificationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.identity.DisburseEmailNotificationRequest;
  return proto.identity.DisburseEmailNotificationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.identity.DisburseEmailNotificationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.identity.DisburseEmailNotificationRequest}
 */
proto.identity.DisburseEmailNotificationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.identity.Recipient;
      reader.readMessage(value,proto.identity.Recipient.deserializeBinaryFromReader);
      msg.addRecipients(value);
      break;
    case 2:
      var value = new proto.identity.Disbursement;
      reader.readMessage(value,proto.identity.Disbursement.deserializeBinaryFromReader);
      msg.setDisbursement(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.identity.DisburseEmailNotificationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.identity.DisburseEmailNotificationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.identity.DisburseEmailNotificationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.DisburseEmailNotificationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRecipientsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.identity.Recipient.serializeBinaryToWriter
    );
  }
  f = message.getDisbursement();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.identity.Disbursement.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Recipient Recipients = 1;
 * @return {!Array<!proto.identity.Recipient>}
 */
proto.identity.DisburseEmailNotificationRequest.prototype.getRecipientsList = function() {
  return /** @type{!Array<!proto.identity.Recipient>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.identity.Recipient, 1));
};


/**
 * @param {!Array<!proto.identity.Recipient>} value
 * @return {!proto.identity.DisburseEmailNotificationRequest} returns this
*/
proto.identity.DisburseEmailNotificationRequest.prototype.setRecipientsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.identity.Recipient=} opt_value
 * @param {number=} opt_index
 * @return {!proto.identity.Recipient}
 */
proto.identity.DisburseEmailNotificationRequest.prototype.addRecipients = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.identity.Recipient, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.identity.DisburseEmailNotificationRequest} returns this
 */
proto.identity.DisburseEmailNotificationRequest.prototype.clearRecipientsList = function() {
  return this.setRecipientsList([]);
};


/**
 * optional Disbursement Disbursement = 2;
 * @return {?proto.identity.Disbursement}
 */
proto.identity.DisburseEmailNotificationRequest.prototype.getDisbursement = function() {
  return /** @type{?proto.identity.Disbursement} */ (
    jspb.Message.getWrapperField(this, proto.identity.Disbursement, 2));
};


/**
 * @param {?proto.identity.Disbursement|undefined} value
 * @return {!proto.identity.DisburseEmailNotificationRequest} returns this
*/
proto.identity.DisburseEmailNotificationRequest.prototype.setDisbursement = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.identity.DisburseEmailNotificationRequest} returns this
 */
proto.identity.DisburseEmailNotificationRequest.prototype.clearDisbursement = function() {
  return this.setDisbursement(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.identity.DisburseEmailNotificationRequest.prototype.hasDisbursement = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.identity.Disbursement.prototype.toObject = function(opt_includeInstance) {
  return proto.identity.Disbursement.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.identity.Disbursement} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.Disbursement.toObject = function(includeInstance, msg) {
  var f, obj = {
    disbursementrequestid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    type: jspb.Message.getFieldWithDefault(msg, 2, ""),
    noofdisbursement: jspb.Message.getFieldWithDefault(msg, 3, ""),
    currency: jspb.Message.getFieldWithDefault(msg, 4, ""),
    totalamount: jspb.Message.getFieldWithDefault(msg, 5, ""),
    remark: jspb.Message.getFieldWithDefault(msg, 6, ""),
    updatedat: jspb.Message.getFieldWithDefault(msg, 7, ""),
    externalreferenceid: jspb.Message.getFieldWithDefault(msg, 8, ""),
    sourceaccountname: jspb.Message.getFieldWithDefault(msg, 9, ""),
    sourceaccountbank: jspb.Message.getFieldWithDefault(msg, 10, ""),
    sourceaccountnumber: jspb.Message.getFieldWithDefault(msg, 11, ""),
    companyname: jspb.Message.getFieldWithDefault(msg, 18, ""),
    brankasreferenceid: jspb.Message.getFieldWithDefault(msg, 19, ""),
    countofsuccessfuldisbursements: jspb.Message.getFieldWithDefault(msg, 20, ""),
    countoffaileddisbursements: jspb.Message.getFieldWithDefault(msg, 21, ""),
    countofpendingdisbursements: jspb.Message.getFieldWithDefault(msg, 22, ""),
    countofdeclineddisbursements: jspb.Message.getFieldWithDefault(msg, 23, ""),
    accountantemailaddress: jspb.Message.getFieldWithDefault(msg, 24, ""),
    description: jspb.Message.getFieldWithDefault(msg, 25, ""),
    disbursementstatus: jspb.Message.getFieldWithDefault(msg, 26, ""),
    destinationaccountbank: jspb.Message.getFieldWithDefault(msg, 27, ""),
    destinationaccountname: jspb.Message.getFieldWithDefault(msg, 28, ""),
    destinationaccountnumber: jspb.Message.getFieldWithDefault(msg, 29, ""),
    destinationamountcurrency: jspb.Message.getFieldWithDefault(msg, 30, ""),
    destinationamountvalue: jspb.Message.getFieldWithDefault(msg, 31, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.identity.Disbursement}
 */
proto.identity.Disbursement.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.identity.Disbursement;
  return proto.identity.Disbursement.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.identity.Disbursement} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.identity.Disbursement}
 */
proto.identity.Disbursement.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisbursementrequestid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setNoofdisbursement(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setTotalamount(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setRemark(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdatedat(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setExternalreferenceid(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceaccountname(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceaccountbank(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceaccountnumber(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanyname(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrankasreferenceid(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountofsuccessfuldisbursements(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountoffaileddisbursements(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountofpendingdisbursements(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountofdeclineddisbursements(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountantemailaddress(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 26:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisbursementstatus(value);
      break;
    case 27:
      var value = /** @type {string} */ (reader.readString());
      msg.setDestinationaccountbank(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setDestinationaccountname(value);
      break;
    case 29:
      var value = /** @type {string} */ (reader.readString());
      msg.setDestinationaccountnumber(value);
      break;
    case 30:
      var value = /** @type {string} */ (reader.readString());
      msg.setDestinationamountcurrency(value);
      break;
    case 31:
      var value = /** @type {string} */ (reader.readString());
      msg.setDestinationamountvalue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.identity.Disbursement.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.identity.Disbursement.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.identity.Disbursement} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.Disbursement.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDisbursementrequestid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getNoofdisbursement();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTotalamount();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getRemark();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getUpdatedat();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getExternalreferenceid();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getSourceaccountname();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getSourceaccountbank();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getSourceaccountnumber();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getCompanyname();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getBrankasreferenceid();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getCountofsuccessfuldisbursements();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getCountoffaileddisbursements();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getCountofpendingdisbursements();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getCountofdeclineddisbursements();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
  f = message.getAccountantemailaddress();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      25,
      f
    );
  }
  f = message.getDisbursementstatus();
  if (f.length > 0) {
    writer.writeString(
      26,
      f
    );
  }
  f = message.getDestinationaccountbank();
  if (f.length > 0) {
    writer.writeString(
      27,
      f
    );
  }
  f = message.getDestinationaccountname();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
  f = message.getDestinationaccountnumber();
  if (f.length > 0) {
    writer.writeString(
      29,
      f
    );
  }
  f = message.getDestinationamountcurrency();
  if (f.length > 0) {
    writer.writeString(
      30,
      f
    );
  }
  f = message.getDestinationamountvalue();
  if (f.length > 0) {
    writer.writeString(
      31,
      f
    );
  }
};


/**
 * optional string DisbursementRequestID = 1;
 * @return {string}
 */
proto.identity.Disbursement.prototype.getDisbursementrequestid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Disbursement} returns this
 */
proto.identity.Disbursement.prototype.setDisbursementrequestid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Type = 2;
 * @return {string}
 */
proto.identity.Disbursement.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Disbursement} returns this
 */
proto.identity.Disbursement.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string NoOfDisbursement = 3;
 * @return {string}
 */
proto.identity.Disbursement.prototype.getNoofdisbursement = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Disbursement} returns this
 */
proto.identity.Disbursement.prototype.setNoofdisbursement = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string Currency = 4;
 * @return {string}
 */
proto.identity.Disbursement.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Disbursement} returns this
 */
proto.identity.Disbursement.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string TotalAmount = 5;
 * @return {string}
 */
proto.identity.Disbursement.prototype.getTotalamount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Disbursement} returns this
 */
proto.identity.Disbursement.prototype.setTotalamount = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string Remark = 6;
 * @return {string}
 */
proto.identity.Disbursement.prototype.getRemark = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Disbursement} returns this
 */
proto.identity.Disbursement.prototype.setRemark = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string UpdatedAt = 7;
 * @return {string}
 */
proto.identity.Disbursement.prototype.getUpdatedat = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Disbursement} returns this
 */
proto.identity.Disbursement.prototype.setUpdatedat = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string ExternalReferenceID = 8;
 * @return {string}
 */
proto.identity.Disbursement.prototype.getExternalreferenceid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Disbursement} returns this
 */
proto.identity.Disbursement.prototype.setExternalreferenceid = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string SourceAccountName = 9;
 * @return {string}
 */
proto.identity.Disbursement.prototype.getSourceaccountname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Disbursement} returns this
 */
proto.identity.Disbursement.prototype.setSourceaccountname = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string SourceAccountBank = 10;
 * @return {string}
 */
proto.identity.Disbursement.prototype.getSourceaccountbank = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Disbursement} returns this
 */
proto.identity.Disbursement.prototype.setSourceaccountbank = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string SourceAccountNumber = 11;
 * @return {string}
 */
proto.identity.Disbursement.prototype.getSourceaccountnumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Disbursement} returns this
 */
proto.identity.Disbursement.prototype.setSourceaccountnumber = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string CompanyName = 18;
 * @return {string}
 */
proto.identity.Disbursement.prototype.getCompanyname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Disbursement} returns this
 */
proto.identity.Disbursement.prototype.setCompanyname = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string BrankasReferenceID = 19;
 * @return {string}
 */
proto.identity.Disbursement.prototype.getBrankasreferenceid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Disbursement} returns this
 */
proto.identity.Disbursement.prototype.setBrankasreferenceid = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string CountOfSuccessfulDisbursements = 20;
 * @return {string}
 */
proto.identity.Disbursement.prototype.getCountofsuccessfuldisbursements = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Disbursement} returns this
 */
proto.identity.Disbursement.prototype.setCountofsuccessfuldisbursements = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string CountOfFailedDisbursements = 21;
 * @return {string}
 */
proto.identity.Disbursement.prototype.getCountoffaileddisbursements = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Disbursement} returns this
 */
proto.identity.Disbursement.prototype.setCountoffaileddisbursements = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional string CountOfPendingDisbursements = 22;
 * @return {string}
 */
proto.identity.Disbursement.prototype.getCountofpendingdisbursements = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Disbursement} returns this
 */
proto.identity.Disbursement.prototype.setCountofpendingdisbursements = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * optional string CountOfDeclinedDisbursements = 23;
 * @return {string}
 */
proto.identity.Disbursement.prototype.getCountofdeclineddisbursements = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Disbursement} returns this
 */
proto.identity.Disbursement.prototype.setCountofdeclineddisbursements = function(value) {
  return jspb.Message.setProto3StringField(this, 23, value);
};


/**
 * optional string AccountantEmailAddress = 24;
 * @return {string}
 */
proto.identity.Disbursement.prototype.getAccountantemailaddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Disbursement} returns this
 */
proto.identity.Disbursement.prototype.setAccountantemailaddress = function(value) {
  return jspb.Message.setProto3StringField(this, 24, value);
};


/**
 * optional string Description = 25;
 * @return {string}
 */
proto.identity.Disbursement.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Disbursement} returns this
 */
proto.identity.Disbursement.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 25, value);
};


/**
 * optional string DisbursementStatus = 26;
 * @return {string}
 */
proto.identity.Disbursement.prototype.getDisbursementstatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Disbursement} returns this
 */
proto.identity.Disbursement.prototype.setDisbursementstatus = function(value) {
  return jspb.Message.setProto3StringField(this, 26, value);
};


/**
 * optional string DestinationAccountBank = 27;
 * @return {string}
 */
proto.identity.Disbursement.prototype.getDestinationaccountbank = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Disbursement} returns this
 */
proto.identity.Disbursement.prototype.setDestinationaccountbank = function(value) {
  return jspb.Message.setProto3StringField(this, 27, value);
};


/**
 * optional string DestinationAccountName = 28;
 * @return {string}
 */
proto.identity.Disbursement.prototype.getDestinationaccountname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Disbursement} returns this
 */
proto.identity.Disbursement.prototype.setDestinationaccountname = function(value) {
  return jspb.Message.setProto3StringField(this, 28, value);
};


/**
 * optional string DestinationAccountNumber = 29;
 * @return {string}
 */
proto.identity.Disbursement.prototype.getDestinationaccountnumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 29, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Disbursement} returns this
 */
proto.identity.Disbursement.prototype.setDestinationaccountnumber = function(value) {
  return jspb.Message.setProto3StringField(this, 29, value);
};


/**
 * optional string DestinationAmountCurrency = 30;
 * @return {string}
 */
proto.identity.Disbursement.prototype.getDestinationamountcurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 30, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Disbursement} returns this
 */
proto.identity.Disbursement.prototype.setDestinationamountcurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 30, value);
};


/**
 * optional string DestinationAmountValue = 31;
 * @return {string}
 */
proto.identity.Disbursement.prototype.getDestinationamountvalue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 31, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Disbursement} returns this
 */
proto.identity.Disbursement.prototype.setDestinationamountvalue = function(value) {
  return jspb.Message.setProto3StringField(this, 31, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.identity.EmailDownloadableStatementRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.identity.EmailDownloadableStatementRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.identity.EmailDownloadableStatementRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.identity.EmailDownloadableStatementRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.EmailDownloadableStatementRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    recipientsList: jspb.Message.toObjectList(msg.getRecipientsList(),
    proto.identity.Recipient.toObject, includeInstance),
    month: jspb.Message.getFieldWithDefault(msg, 2, ""),
    year: jspb.Message.getFieldWithDefault(msg, 3, ""),
    sourceaccountname: jspb.Message.getFieldWithDefault(msg, 4, ""),
    endingcode: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.identity.EmailDownloadableStatementRequest}
 */
proto.identity.EmailDownloadableStatementRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.identity.EmailDownloadableStatementRequest;
  return proto.identity.EmailDownloadableStatementRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.identity.EmailDownloadableStatementRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.identity.EmailDownloadableStatementRequest}
 */
proto.identity.EmailDownloadableStatementRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.identity.Recipient;
      reader.readMessage(value,proto.identity.Recipient.deserializeBinaryFromReader);
      msg.addRecipients(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMonth(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setYear(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceaccountname(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setEndingcode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.identity.EmailDownloadableStatementRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.identity.EmailDownloadableStatementRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.identity.EmailDownloadableStatementRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.EmailDownloadableStatementRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRecipientsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.identity.Recipient.serializeBinaryToWriter
    );
  }
  f = message.getMonth();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getYear();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSourceaccountname();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getEndingcode();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * repeated Recipient Recipients = 1;
 * @return {!Array<!proto.identity.Recipient>}
 */
proto.identity.EmailDownloadableStatementRequest.prototype.getRecipientsList = function() {
  return /** @type{!Array<!proto.identity.Recipient>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.identity.Recipient, 1));
};


/**
 * @param {!Array<!proto.identity.Recipient>} value
 * @return {!proto.identity.EmailDownloadableStatementRequest} returns this
*/
proto.identity.EmailDownloadableStatementRequest.prototype.setRecipientsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.identity.Recipient=} opt_value
 * @param {number=} opt_index
 * @return {!proto.identity.Recipient}
 */
proto.identity.EmailDownloadableStatementRequest.prototype.addRecipients = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.identity.Recipient, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.identity.EmailDownloadableStatementRequest} returns this
 */
proto.identity.EmailDownloadableStatementRequest.prototype.clearRecipientsList = function() {
  return this.setRecipientsList([]);
};


/**
 * optional string Month = 2;
 * @return {string}
 */
proto.identity.EmailDownloadableStatementRequest.prototype.getMonth = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.EmailDownloadableStatementRequest} returns this
 */
proto.identity.EmailDownloadableStatementRequest.prototype.setMonth = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Year = 3;
 * @return {string}
 */
proto.identity.EmailDownloadableStatementRequest.prototype.getYear = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.EmailDownloadableStatementRequest} returns this
 */
proto.identity.EmailDownloadableStatementRequest.prototype.setYear = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string SourceAccountName = 4;
 * @return {string}
 */
proto.identity.EmailDownloadableStatementRequest.prototype.getSourceaccountname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.EmailDownloadableStatementRequest} returns this
 */
proto.identity.EmailDownloadableStatementRequest.prototype.setSourceaccountname = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string EndingCode = 5;
 * @return {string}
 */
proto.identity.EmailDownloadableStatementRequest.prototype.getEndingcode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.EmailDownloadableStatementRequest} returns this
 */
proto.identity.EmailDownloadableStatementRequest.prototype.setEndingcode = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.identity.EmailDownloadableStatementResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.identity.EmailDownloadableStatementResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.identity.EmailDownloadableStatementResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.identity.EmailDownloadableStatementResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.EmailDownloadableStatementResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    resultsList: jspb.Message.toObjectList(msg.getResultsList(),
    proto.identity.EmailNotificationResult.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.identity.EmailDownloadableStatementResponse}
 */
proto.identity.EmailDownloadableStatementResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.identity.EmailDownloadableStatementResponse;
  return proto.identity.EmailDownloadableStatementResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.identity.EmailDownloadableStatementResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.identity.EmailDownloadableStatementResponse}
 */
proto.identity.EmailDownloadableStatementResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.identity.EmailNotificationResult;
      reader.readMessage(value,proto.identity.EmailNotificationResult.deserializeBinaryFromReader);
      msg.addResults(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.identity.EmailDownloadableStatementResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.identity.EmailDownloadableStatementResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.identity.EmailDownloadableStatementResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.EmailDownloadableStatementResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResultsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.identity.EmailNotificationResult.serializeBinaryToWriter
    );
  }
};


/**
 * repeated EmailNotificationResult Results = 1;
 * @return {!Array<!proto.identity.EmailNotificationResult>}
 */
proto.identity.EmailDownloadableStatementResponse.prototype.getResultsList = function() {
  return /** @type{!Array<!proto.identity.EmailNotificationResult>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.identity.EmailNotificationResult, 1));
};


/**
 * @param {!Array<!proto.identity.EmailNotificationResult>} value
 * @return {!proto.identity.EmailDownloadableStatementResponse} returns this
*/
proto.identity.EmailDownloadableStatementResponse.prototype.setResultsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.identity.EmailNotificationResult=} opt_value
 * @param {number=} opt_index
 * @return {!proto.identity.EmailNotificationResult}
 */
proto.identity.EmailDownloadableStatementResponse.prototype.addResults = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.identity.EmailNotificationResult, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.identity.EmailDownloadableStatementResponse} returns this
 */
proto.identity.EmailDownloadableStatementResponse.prototype.clearResultsList = function() {
  return this.setResultsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.identity.EmailFDSEventAlertNotificationRequest.repeatedFields_ = [1,2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.identity.EmailFDSEventAlertNotificationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.identity.EmailFDSEventAlertNotificationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.identity.EmailFDSEventAlertNotificationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.EmailFDSEventAlertNotificationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    toList: jspb.Message.toObjectList(msg.getToList(),
    proto.identity.Recipient.toObject, includeInstance),
    ccList: jspb.Message.toObjectList(msg.getCcList(),
    proto.identity.Recipient.toObject, includeInstance),
    bccList: jspb.Message.toObjectList(msg.getBccList(),
    proto.identity.Recipient.toObject, includeInstance),
    alertlevel: jspb.Message.getFieldWithDefault(msg, 4, ""),
    product: jspb.Message.getFieldWithDefault(msg, 5, ""),
    environment: jspb.Message.getFieldWithDefault(msg, 6, ""),
    event: jspb.Message.getFieldWithDefault(msg, 7, ""),
    action: jspb.Message.getFieldWithDefault(msg, 8, ""),
    formatteddatetime: jspb.Message.getFieldWithDefault(msg, 9, ""),
    eventid: jspb.Message.getFieldWithDefault(msg, 10, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.identity.EmailFDSEventAlertNotificationRequest}
 */
proto.identity.EmailFDSEventAlertNotificationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.identity.EmailFDSEventAlertNotificationRequest;
  return proto.identity.EmailFDSEventAlertNotificationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.identity.EmailFDSEventAlertNotificationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.identity.EmailFDSEventAlertNotificationRequest}
 */
proto.identity.EmailFDSEventAlertNotificationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.identity.Recipient;
      reader.readMessage(value,proto.identity.Recipient.deserializeBinaryFromReader);
      msg.addTo(value);
      break;
    case 2:
      var value = new proto.identity.Recipient;
      reader.readMessage(value,proto.identity.Recipient.deserializeBinaryFromReader);
      msg.addCc(value);
      break;
    case 3:
      var value = new proto.identity.Recipient;
      reader.readMessage(value,proto.identity.Recipient.deserializeBinaryFromReader);
      msg.addBcc(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAlertlevel(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setProduct(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setEnvironment(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setEvent(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setAction(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setFormatteddatetime(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setEventid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.identity.EmailFDSEventAlertNotificationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.identity.EmailFDSEventAlertNotificationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.identity.EmailFDSEventAlertNotificationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.EmailFDSEventAlertNotificationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getToList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.identity.Recipient.serializeBinaryToWriter
    );
  }
  f = message.getCcList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.identity.Recipient.serializeBinaryToWriter
    );
  }
  f = message.getBccList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.identity.Recipient.serializeBinaryToWriter
    );
  }
  f = message.getAlertlevel();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getProduct();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getEnvironment();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getEvent();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getAction();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getFormatteddatetime();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getEventid();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
};


/**
 * repeated Recipient To = 1;
 * @return {!Array<!proto.identity.Recipient>}
 */
proto.identity.EmailFDSEventAlertNotificationRequest.prototype.getToList = function() {
  return /** @type{!Array<!proto.identity.Recipient>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.identity.Recipient, 1));
};


/**
 * @param {!Array<!proto.identity.Recipient>} value
 * @return {!proto.identity.EmailFDSEventAlertNotificationRequest} returns this
*/
proto.identity.EmailFDSEventAlertNotificationRequest.prototype.setToList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.identity.Recipient=} opt_value
 * @param {number=} opt_index
 * @return {!proto.identity.Recipient}
 */
proto.identity.EmailFDSEventAlertNotificationRequest.prototype.addTo = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.identity.Recipient, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.identity.EmailFDSEventAlertNotificationRequest} returns this
 */
proto.identity.EmailFDSEventAlertNotificationRequest.prototype.clearToList = function() {
  return this.setToList([]);
};


/**
 * repeated Recipient Cc = 2;
 * @return {!Array<!proto.identity.Recipient>}
 */
proto.identity.EmailFDSEventAlertNotificationRequest.prototype.getCcList = function() {
  return /** @type{!Array<!proto.identity.Recipient>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.identity.Recipient, 2));
};


/**
 * @param {!Array<!proto.identity.Recipient>} value
 * @return {!proto.identity.EmailFDSEventAlertNotificationRequest} returns this
*/
proto.identity.EmailFDSEventAlertNotificationRequest.prototype.setCcList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.identity.Recipient=} opt_value
 * @param {number=} opt_index
 * @return {!proto.identity.Recipient}
 */
proto.identity.EmailFDSEventAlertNotificationRequest.prototype.addCc = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.identity.Recipient, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.identity.EmailFDSEventAlertNotificationRequest} returns this
 */
proto.identity.EmailFDSEventAlertNotificationRequest.prototype.clearCcList = function() {
  return this.setCcList([]);
};


/**
 * repeated Recipient Bcc = 3;
 * @return {!Array<!proto.identity.Recipient>}
 */
proto.identity.EmailFDSEventAlertNotificationRequest.prototype.getBccList = function() {
  return /** @type{!Array<!proto.identity.Recipient>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.identity.Recipient, 3));
};


/**
 * @param {!Array<!proto.identity.Recipient>} value
 * @return {!proto.identity.EmailFDSEventAlertNotificationRequest} returns this
*/
proto.identity.EmailFDSEventAlertNotificationRequest.prototype.setBccList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.identity.Recipient=} opt_value
 * @param {number=} opt_index
 * @return {!proto.identity.Recipient}
 */
proto.identity.EmailFDSEventAlertNotificationRequest.prototype.addBcc = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.identity.Recipient, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.identity.EmailFDSEventAlertNotificationRequest} returns this
 */
proto.identity.EmailFDSEventAlertNotificationRequest.prototype.clearBccList = function() {
  return this.setBccList([]);
};


/**
 * optional string AlertLevel = 4;
 * @return {string}
 */
proto.identity.EmailFDSEventAlertNotificationRequest.prototype.getAlertlevel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.EmailFDSEventAlertNotificationRequest} returns this
 */
proto.identity.EmailFDSEventAlertNotificationRequest.prototype.setAlertlevel = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Product = 5;
 * @return {string}
 */
proto.identity.EmailFDSEventAlertNotificationRequest.prototype.getProduct = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.EmailFDSEventAlertNotificationRequest} returns this
 */
proto.identity.EmailFDSEventAlertNotificationRequest.prototype.setProduct = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string Environment = 6;
 * @return {string}
 */
proto.identity.EmailFDSEventAlertNotificationRequest.prototype.getEnvironment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.EmailFDSEventAlertNotificationRequest} returns this
 */
proto.identity.EmailFDSEventAlertNotificationRequest.prototype.setEnvironment = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string Event = 7;
 * @return {string}
 */
proto.identity.EmailFDSEventAlertNotificationRequest.prototype.getEvent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.EmailFDSEventAlertNotificationRequest} returns this
 */
proto.identity.EmailFDSEventAlertNotificationRequest.prototype.setEvent = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string Action = 8;
 * @return {string}
 */
proto.identity.EmailFDSEventAlertNotificationRequest.prototype.getAction = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.EmailFDSEventAlertNotificationRequest} returns this
 */
proto.identity.EmailFDSEventAlertNotificationRequest.prototype.setAction = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string FormattedDateTime = 9;
 * @return {string}
 */
proto.identity.EmailFDSEventAlertNotificationRequest.prototype.getFormatteddatetime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.EmailFDSEventAlertNotificationRequest} returns this
 */
proto.identity.EmailFDSEventAlertNotificationRequest.prototype.setFormatteddatetime = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string EventID = 10;
 * @return {string}
 */
proto.identity.EmailFDSEventAlertNotificationRequest.prototype.getEventid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.EmailFDSEventAlertNotificationRequest} returns this
 */
proto.identity.EmailFDSEventAlertNotificationRequest.prototype.setEventid = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.identity.EmailFDSEventAlertNotificationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.identity.EmailFDSEventAlertNotificationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.identity.EmailFDSEventAlertNotificationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.EmailFDSEventAlertNotificationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    results: (f = msg.getResults()) && proto.identity.EmailGroupNotificationResult.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.identity.EmailFDSEventAlertNotificationResponse}
 */
proto.identity.EmailFDSEventAlertNotificationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.identity.EmailFDSEventAlertNotificationResponse;
  return proto.identity.EmailFDSEventAlertNotificationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.identity.EmailFDSEventAlertNotificationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.identity.EmailFDSEventAlertNotificationResponse}
 */
proto.identity.EmailFDSEventAlertNotificationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.identity.EmailGroupNotificationResult;
      reader.readMessage(value,proto.identity.EmailGroupNotificationResult.deserializeBinaryFromReader);
      msg.setResults(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.identity.EmailFDSEventAlertNotificationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.identity.EmailFDSEventAlertNotificationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.identity.EmailFDSEventAlertNotificationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.EmailFDSEventAlertNotificationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResults();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.identity.EmailGroupNotificationResult.serializeBinaryToWriter
    );
  }
};


/**
 * optional EmailGroupNotificationResult Results = 1;
 * @return {?proto.identity.EmailGroupNotificationResult}
 */
proto.identity.EmailFDSEventAlertNotificationResponse.prototype.getResults = function() {
  return /** @type{?proto.identity.EmailGroupNotificationResult} */ (
    jspb.Message.getWrapperField(this, proto.identity.EmailGroupNotificationResult, 1));
};


/**
 * @param {?proto.identity.EmailGroupNotificationResult|undefined} value
 * @return {!proto.identity.EmailFDSEventAlertNotificationResponse} returns this
*/
proto.identity.EmailFDSEventAlertNotificationResponse.prototype.setResults = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.identity.EmailFDSEventAlertNotificationResponse} returns this
 */
proto.identity.EmailFDSEventAlertNotificationResponse.prototype.clearResults = function() {
  return this.setResults(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.identity.EmailFDSEventAlertNotificationResponse.prototype.hasResults = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.identity.User.prototype.toObject = function(opt_includeInstance) {
  return proto.identity.User.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.identity.User} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.User.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    email: jspb.Message.getFieldWithDefault(msg, 3, ""),
    emailverified: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    emailsubscription: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    phonenumber: jspb.Message.getFieldWithDefault(msg, 6, ""),
    mobilephonenumber: jspb.Message.getFieldWithDefault(msg, 7, ""),
    designation: jspb.Message.getFieldWithDefault(msg, 8, ""),
    role: jspb.Message.getFieldWithDefault(msg, 9, ""),
    roleid: jspb.Message.getFieldWithDefault(msg, 10, ""),
    countrycode: jspb.Message.getFieldWithDefault(msg, 11, ""),
    userrole: (f = msg.getUserrole()) && proto.identity.Role.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.identity.User}
 */
proto.identity.User.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.identity.User;
  return proto.identity.User.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.identity.User} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.identity.User}
 */
proto.identity.User.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEmailverified(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEmailsubscription(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhonenumber(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobilephonenumber(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setDesignation(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setRole(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoleid(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountrycode(value);
      break;
    case 12:
      var value = new proto.identity.Role;
      reader.readMessage(value,proto.identity.Role.deserializeBinaryFromReader);
      msg.setUserrole(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.identity.User.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.identity.User.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.identity.User} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.User.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEmailverified();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getEmailsubscription();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getPhonenumber();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getMobilephonenumber();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getDesignation();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getRole();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getRoleid();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getCountrycode();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getUserrole();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.identity.Role.serializeBinaryToWriter
    );
  }
};


/**
 * optional string ID = 1;
 * @return {string}
 */
proto.identity.User.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.User} returns this
 */
proto.identity.User.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Name = 2;
 * @return {string}
 */
proto.identity.User.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.User} returns this
 */
proto.identity.User.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Email = 3;
 * @return {string}
 */
proto.identity.User.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.User} returns this
 */
proto.identity.User.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool EmailVerified = 4;
 * @return {boolean}
 */
proto.identity.User.prototype.getEmailverified = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.identity.User} returns this
 */
proto.identity.User.prototype.setEmailverified = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool EmailSubscription = 5;
 * @return {boolean}
 */
proto.identity.User.prototype.getEmailsubscription = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.identity.User} returns this
 */
proto.identity.User.prototype.setEmailsubscription = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional string PhoneNumber = 6;
 * @return {string}
 */
proto.identity.User.prototype.getPhonenumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.User} returns this
 */
proto.identity.User.prototype.setPhonenumber = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string MobilePhoneNumber = 7;
 * @return {string}
 */
proto.identity.User.prototype.getMobilephonenumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.User} returns this
 */
proto.identity.User.prototype.setMobilephonenumber = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string Designation = 8;
 * @return {string}
 */
proto.identity.User.prototype.getDesignation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.User} returns this
 */
proto.identity.User.prototype.setDesignation = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string Role = 9;
 * @return {string}
 */
proto.identity.User.prototype.getRole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.User} returns this
 */
proto.identity.User.prototype.setRole = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string RoleID = 10;
 * @return {string}
 */
proto.identity.User.prototype.getRoleid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.User} returns this
 */
proto.identity.User.prototype.setRoleid = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string CountryCode = 11;
 * @return {string}
 */
proto.identity.User.prototype.getCountrycode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.User} returns this
 */
proto.identity.User.prototype.setCountrycode = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional Role UserRole = 12;
 * @return {?proto.identity.Role}
 */
proto.identity.User.prototype.getUserrole = function() {
  return /** @type{?proto.identity.Role} */ (
    jspb.Message.getWrapperField(this, proto.identity.Role, 12));
};


/**
 * @param {?proto.identity.Role|undefined} value
 * @return {!proto.identity.User} returns this
*/
proto.identity.User.prototype.setUserrole = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.identity.User} returns this
 */
proto.identity.User.prototype.clearUserrole = function() {
  return this.setUserrole(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.identity.User.prototype.hasUserrole = function() {
  return jspb.Message.getField(this, 12) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.identity.UserRole.prototype.toObject = function(opt_includeInstance) {
  return proto.identity.UserRole.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.identity.UserRole} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.UserRole.toObject = function(includeInstance, msg) {
  var f, obj = {
    userid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    businessid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    roleid: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.identity.UserRole}
 */
proto.identity.UserRole.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.identity.UserRole;
  return proto.identity.UserRole.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.identity.UserRole} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.identity.UserRole}
 */
proto.identity.UserRole.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBusinessid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoleid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.identity.UserRole.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.identity.UserRole.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.identity.UserRole} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.UserRole.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBusinessid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRoleid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string UserID = 1;
 * @return {string}
 */
proto.identity.UserRole.prototype.getUserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.UserRole} returns this
 */
proto.identity.UserRole.prototype.setUserid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string BusinessID = 2;
 * @return {string}
 */
proto.identity.UserRole.prototype.getBusinessid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.UserRole} returns this
 */
proto.identity.UserRole.prototype.setBusinessid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string RoleID = 3;
 * @return {string}
 */
proto.identity.UserRole.prototype.getRoleid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.UserRole} returns this
 */
proto.identity.UserRole.prototype.setRoleid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.identity.Org.prototype.toObject = function(opt_includeInstance) {
  return proto.identity.Org.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.identity.Org} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.Org.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    addressline1: jspb.Message.getFieldWithDefault(msg, 2, ""),
    addressline2: jspb.Message.getFieldWithDefault(msg, 3, ""),
    city: jspb.Message.getFieldWithDefault(msg, 4, ""),
    province: jspb.Message.getFieldWithDefault(msg, 5, ""),
    postalcode: jspb.Message.getFieldWithDefault(msg, 6, ""),
    country: jspb.Message.getFieldWithDefault(msg, 7, ""),
    industry: jspb.Message.getFieldWithDefault(msg, 8, ""),
    description: jspb.Message.getFieldWithDefault(msg, 9, ""),
    logourl: jspb.Message.getFieldWithDefault(msg, 10, ""),
    phonenumber: jspb.Message.getFieldWithDefault(msg, 12, ""),
    phonenumbercountrycode: jspb.Message.getFieldWithDefault(msg, 13, ""),
    timezone: jspb.Message.getFieldWithDefault(msg, 14, ""),
    kycstatus: jspb.Message.getFieldWithDefault(msg, 15, 0),
    islive: jspb.Message.getBooleanFieldWithDefault(msg, 16, false),
    orgtype: jspb.Message.getFieldWithDefault(msg, 17, 0),
    taxidentificationnumber: jspb.Message.getFieldWithDefault(msg, 18, ""),
    id: jspb.Message.getFieldWithDefault(msg, 19, ""),
    logoname: jspb.Message.getFieldWithDefault(msg, 20, ""),
    region: jspb.Message.getFieldWithDefault(msg, 21, ""),
    noemployees: jspb.Message.getFieldWithDefault(msg, 22, ""),
    transactionspermonth: jspb.Message.getFieldWithDefault(msg, 23, ""),
    role: jspb.Message.getFieldWithDefault(msg, 24, ""),
    website: jspb.Message.getFieldWithDefault(msg, 25, ""),
    businesstype: jspb.Message.getFieldWithDefault(msg, 26, ""),
    placeofestablishment: jspb.Message.getFieldWithDefault(msg, 27, ""),
    dateofestablishment: jspb.Message.getFieldWithDefault(msg, 28, ""),
    hasphysicalstore: jspb.Message.getBooleanFieldWithDefault(msg, 29, false),
    companyprofile: jspb.Message.getFieldWithDefault(msg, 30, ""),
    subindustry: jspb.Message.getFieldWithDefault(msg, 31, ""),
    agreement: jspb.Message.getFieldWithDefault(msg, 32, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.identity.Org}
 */
proto.identity.Org.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.identity.Org;
  return proto.identity.Org.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.identity.Org} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.identity.Org}
 */
proto.identity.Org.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddressline1(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddressline2(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCity(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setProvince(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setPostalcode(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setIndustry(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setLogourl(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhonenumber(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhonenumbercountrycode(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimezone(value);
      break;
    case 15:
      var value = /** @type {!proto.identity.KYCStatus} */ (reader.readEnum());
      msg.setKycstatus(value);
      break;
    case 16:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIslive(value);
      break;
    case 17:
      var value = /** @type {!proto.identity.OrgType} */ (reader.readEnum());
      msg.setOrgtype(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaxidentificationnumber(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setLogoname(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegion(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setNoemployees(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransactionspermonth(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.setRole(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readString());
      msg.setWebsite(value);
      break;
    case 26:
      var value = /** @type {string} */ (reader.readString());
      msg.setBusinesstype(value);
      break;
    case 27:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlaceofestablishment(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setDateofestablishment(value);
      break;
    case 29:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasphysicalstore(value);
      break;
    case 30:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanyprofile(value);
      break;
    case 31:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubindustry(value);
      break;
    case 32:
      var value = /** @type {!proto.identity.Agreement} */ (reader.readEnum());
      msg.setAgreement(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.identity.Org.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.identity.Org.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.identity.Org} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.Org.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAddressline1();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAddressline2();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getProvince();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPostalcode();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getIndustry();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getLogourl();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getPhonenumber();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getPhonenumbercountrycode();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getTimezone();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getKycstatus();
  if (f !== 0.0) {
    writer.writeEnum(
      15,
      f
    );
  }
  f = message.getIslive();
  if (f) {
    writer.writeBool(
      16,
      f
    );
  }
  f = message.getOrgtype();
  if (f !== 0.0) {
    writer.writeEnum(
      17,
      f
    );
  }
  f = message.getTaxidentificationnumber();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getLogoname();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getRegion();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getNoemployees();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getTransactionspermonth();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
  f = message.getRole();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
  f = message.getWebsite();
  if (f.length > 0) {
    writer.writeString(
      25,
      f
    );
  }
  f = message.getBusinesstype();
  if (f.length > 0) {
    writer.writeString(
      26,
      f
    );
  }
  f = message.getPlaceofestablishment();
  if (f.length > 0) {
    writer.writeString(
      27,
      f
    );
  }
  f = message.getDateofestablishment();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
  f = message.getHasphysicalstore();
  if (f) {
    writer.writeBool(
      29,
      f
    );
  }
  f = message.getCompanyprofile();
  if (f.length > 0) {
    writer.writeString(
      30,
      f
    );
  }
  f = message.getSubindustry();
  if (f.length > 0) {
    writer.writeString(
      31,
      f
    );
  }
  f = message.getAgreement();
  if (f !== 0.0) {
    writer.writeEnum(
      32,
      f
    );
  }
};


/**
 * optional string Name = 1;
 * @return {string}
 */
proto.identity.Org.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Org} returns this
 */
proto.identity.Org.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string AddressLine1 = 2;
 * @return {string}
 */
proto.identity.Org.prototype.getAddressline1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Org} returns this
 */
proto.identity.Org.prototype.setAddressline1 = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string AddressLine2 = 3;
 * @return {string}
 */
proto.identity.Org.prototype.getAddressline2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Org} returns this
 */
proto.identity.Org.prototype.setAddressline2 = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string City = 4;
 * @return {string}
 */
proto.identity.Org.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Org} returns this
 */
proto.identity.Org.prototype.setCity = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Province = 5;
 * @return {string}
 */
proto.identity.Org.prototype.getProvince = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Org} returns this
 */
proto.identity.Org.prototype.setProvince = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string PostalCode = 6;
 * @return {string}
 */
proto.identity.Org.prototype.getPostalcode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Org} returns this
 */
proto.identity.Org.prototype.setPostalcode = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string Country = 7;
 * @return {string}
 */
proto.identity.Org.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Org} returns this
 */
proto.identity.Org.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string Industry = 8;
 * @return {string}
 */
proto.identity.Org.prototype.getIndustry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Org} returns this
 */
proto.identity.Org.prototype.setIndustry = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string Description = 9;
 * @return {string}
 */
proto.identity.Org.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Org} returns this
 */
proto.identity.Org.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string LogoURL = 10;
 * @return {string}
 */
proto.identity.Org.prototype.getLogourl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Org} returns this
 */
proto.identity.Org.prototype.setLogourl = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string PhoneNumber = 12;
 * @return {string}
 */
proto.identity.Org.prototype.getPhonenumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Org} returns this
 */
proto.identity.Org.prototype.setPhonenumber = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string PhoneNumberCountryCode = 13;
 * @return {string}
 */
proto.identity.Org.prototype.getPhonenumbercountrycode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Org} returns this
 */
proto.identity.Org.prototype.setPhonenumbercountrycode = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string Timezone = 14;
 * @return {string}
 */
proto.identity.Org.prototype.getTimezone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Org} returns this
 */
proto.identity.Org.prototype.setTimezone = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional KYCStatus KYCStatus = 15;
 * @return {!proto.identity.KYCStatus}
 */
proto.identity.Org.prototype.getKycstatus = function() {
  return /** @type {!proto.identity.KYCStatus} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {!proto.identity.KYCStatus} value
 * @return {!proto.identity.Org} returns this
 */
proto.identity.Org.prototype.setKycstatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 15, value);
};


/**
 * optional bool IsLive = 16;
 * @return {boolean}
 */
proto.identity.Org.prototype.getIslive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 16, false));
};


/**
 * @param {boolean} value
 * @return {!proto.identity.Org} returns this
 */
proto.identity.Org.prototype.setIslive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 16, value);
};


/**
 * optional OrgType OrgType = 17;
 * @return {!proto.identity.OrgType}
 */
proto.identity.Org.prototype.getOrgtype = function() {
  return /** @type {!proto.identity.OrgType} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {!proto.identity.OrgType} value
 * @return {!proto.identity.Org} returns this
 */
proto.identity.Org.prototype.setOrgtype = function(value) {
  return jspb.Message.setProto3EnumField(this, 17, value);
};


/**
 * optional string TaxIdentificationNumber = 18;
 * @return {string}
 */
proto.identity.Org.prototype.getTaxidentificationnumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Org} returns this
 */
proto.identity.Org.prototype.setTaxidentificationnumber = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string ID = 19;
 * @return {string}
 */
proto.identity.Org.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Org} returns this
 */
proto.identity.Org.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string LogoName = 20;
 * @return {string}
 */
proto.identity.Org.prototype.getLogoname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Org} returns this
 */
proto.identity.Org.prototype.setLogoname = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string Region = 21;
 * @return {string}
 */
proto.identity.Org.prototype.getRegion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Org} returns this
 */
proto.identity.Org.prototype.setRegion = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional string NoEmployees = 22;
 * @return {string}
 */
proto.identity.Org.prototype.getNoemployees = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Org} returns this
 */
proto.identity.Org.prototype.setNoemployees = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * optional string TransactionsPerMonth = 23;
 * @return {string}
 */
proto.identity.Org.prototype.getTransactionspermonth = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Org} returns this
 */
proto.identity.Org.prototype.setTransactionspermonth = function(value) {
  return jspb.Message.setProto3StringField(this, 23, value);
};


/**
 * optional string Role = 24;
 * @return {string}
 */
proto.identity.Org.prototype.getRole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Org} returns this
 */
proto.identity.Org.prototype.setRole = function(value) {
  return jspb.Message.setProto3StringField(this, 24, value);
};


/**
 * optional string Website = 25;
 * @return {string}
 */
proto.identity.Org.prototype.getWebsite = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Org} returns this
 */
proto.identity.Org.prototype.setWebsite = function(value) {
  return jspb.Message.setProto3StringField(this, 25, value);
};


/**
 * optional string BusinessType = 26;
 * @return {string}
 */
proto.identity.Org.prototype.getBusinesstype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Org} returns this
 */
proto.identity.Org.prototype.setBusinesstype = function(value) {
  return jspb.Message.setProto3StringField(this, 26, value);
};


/**
 * optional string PlaceOfEstablishment = 27;
 * @return {string}
 */
proto.identity.Org.prototype.getPlaceofestablishment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Org} returns this
 */
proto.identity.Org.prototype.setPlaceofestablishment = function(value) {
  return jspb.Message.setProto3StringField(this, 27, value);
};


/**
 * optional string DateOfEstablishment = 28;
 * @return {string}
 */
proto.identity.Org.prototype.getDateofestablishment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Org} returns this
 */
proto.identity.Org.prototype.setDateofestablishment = function(value) {
  return jspb.Message.setProto3StringField(this, 28, value);
};


/**
 * optional bool HasPhysicalStore = 29;
 * @return {boolean}
 */
proto.identity.Org.prototype.getHasphysicalstore = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 29, false));
};


/**
 * @param {boolean} value
 * @return {!proto.identity.Org} returns this
 */
proto.identity.Org.prototype.setHasphysicalstore = function(value) {
  return jspb.Message.setProto3BooleanField(this, 29, value);
};


/**
 * optional string CompanyProfile = 30;
 * @return {string}
 */
proto.identity.Org.prototype.getCompanyprofile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 30, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Org} returns this
 */
proto.identity.Org.prototype.setCompanyprofile = function(value) {
  return jspb.Message.setProto3StringField(this, 30, value);
};


/**
 * optional string SubIndustry = 31;
 * @return {string}
 */
proto.identity.Org.prototype.getSubindustry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 31, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Org} returns this
 */
proto.identity.Org.prototype.setSubindustry = function(value) {
  return jspb.Message.setProto3StringField(this, 31, value);
};


/**
 * optional Agreement Agreement = 32;
 * @return {!proto.identity.Agreement}
 */
proto.identity.Org.prototype.getAgreement = function() {
  return /** @type {!proto.identity.Agreement} */ (jspb.Message.getFieldWithDefault(this, 32, 0));
};


/**
 * @param {!proto.identity.Agreement} value
 * @return {!proto.identity.Org} returns this
 */
proto.identity.Org.prototype.setAgreement = function(value) {
  return jspb.Message.setProto3EnumField(this, 32, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.identity.Business.prototype.toObject = function(opt_includeInstance) {
  return proto.identity.Business.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.identity.Business} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.Business.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    country: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.identity.Business}
 */
proto.identity.Business.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.identity.Business;
  return proto.identity.Business.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.identity.Business} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.identity.Business}
 */
proto.identity.Business.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.identity.Business.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.identity.Business.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.identity.Business} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.Business.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string ID = 1;
 * @return {string}
 */
proto.identity.Business.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Business} returns this
 */
proto.identity.Business.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Name = 2;
 * @return {string}
 */
proto.identity.Business.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Business} returns this
 */
proto.identity.Business.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Country = 3;
 * @return {string}
 */
proto.identity.Business.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Business} returns this
 */
proto.identity.Business.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.identity.BusinessInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.identity.BusinessInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.identity.BusinessInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.BusinessInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    addressline1: jspb.Message.getFieldWithDefault(msg, 3, ""),
    addressline2: jspb.Message.getFieldWithDefault(msg, 4, ""),
    city: jspb.Message.getFieldWithDefault(msg, 5, ""),
    stateprovince: jspb.Message.getFieldWithDefault(msg, 6, ""),
    country: jspb.Message.getFieldWithDefault(msg, 7, 0),
    emailaddress: jspb.Message.getFieldWithDefault(msg, 8, ""),
    mobilecountrycode: jspb.Message.getFieldWithDefault(msg, 9, ""),
    mobilenumber: jspb.Message.getFieldWithDefault(msg, 10, ""),
    orgid: jspb.Message.getFieldWithDefault(msg, 11, ""),
    district: jspb.Message.getFieldWithDefault(msg, 12, ""),
    subdistrict: jspb.Message.getFieldWithDefault(msg, 13, ""),
    enabled: jspb.Message.getBooleanFieldWithDefault(msg, 14, false),
    supportretries: jspb.Message.getBooleanFieldWithDefault(msg, 15, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.identity.BusinessInfo}
 */
proto.identity.BusinessInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.identity.BusinessInfo;
  return proto.identity.BusinessInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.identity.BusinessInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.identity.BusinessInfo}
 */
proto.identity.BusinessInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddressline1(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddressline2(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCity(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setStateprovince(value);
      break;
    case 7:
      var value = /** @type {!proto.identity.CountryISO3166} */ (reader.readEnum());
      msg.setCountry(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmailaddress(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobilecountrycode(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobilenumber(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrgid(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setDistrict(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubdistrict(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSupportretries(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.identity.BusinessInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.identity.BusinessInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.identity.BusinessInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.BusinessInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAddressline1();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAddressline2();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getStateprovince();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCountry();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getEmailaddress();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getMobilecountrycode();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getMobilenumber();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getOrgid();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getDistrict();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getSubdistrict();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
  f = message.getSupportretries();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
};


/**
 * optional string ID = 1;
 * @return {string}
 */
proto.identity.BusinessInfo.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.BusinessInfo} returns this
 */
proto.identity.BusinessInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Name = 2;
 * @return {string}
 */
proto.identity.BusinessInfo.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.BusinessInfo} returns this
 */
proto.identity.BusinessInfo.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string AddressLine1 = 3;
 * @return {string}
 */
proto.identity.BusinessInfo.prototype.getAddressline1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.BusinessInfo} returns this
 */
proto.identity.BusinessInfo.prototype.setAddressline1 = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string AddressLine2 = 4;
 * @return {string}
 */
proto.identity.BusinessInfo.prototype.getAddressline2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.BusinessInfo} returns this
 */
proto.identity.BusinessInfo.prototype.setAddressline2 = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string City = 5;
 * @return {string}
 */
proto.identity.BusinessInfo.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.BusinessInfo} returns this
 */
proto.identity.BusinessInfo.prototype.setCity = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string StateProvince = 6;
 * @return {string}
 */
proto.identity.BusinessInfo.prototype.getStateprovince = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.BusinessInfo} returns this
 */
proto.identity.BusinessInfo.prototype.setStateprovince = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional CountryISO3166 Country = 7;
 * @return {!proto.identity.CountryISO3166}
 */
proto.identity.BusinessInfo.prototype.getCountry = function() {
  return /** @type {!proto.identity.CountryISO3166} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.identity.CountryISO3166} value
 * @return {!proto.identity.BusinessInfo} returns this
 */
proto.identity.BusinessInfo.prototype.setCountry = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional string EmailAddress = 8;
 * @return {string}
 */
proto.identity.BusinessInfo.prototype.getEmailaddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.BusinessInfo} returns this
 */
proto.identity.BusinessInfo.prototype.setEmailaddress = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string MobileCountryCode = 9;
 * @return {string}
 */
proto.identity.BusinessInfo.prototype.getMobilecountrycode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.BusinessInfo} returns this
 */
proto.identity.BusinessInfo.prototype.setMobilecountrycode = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string MobileNumber = 10;
 * @return {string}
 */
proto.identity.BusinessInfo.prototype.getMobilenumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.BusinessInfo} returns this
 */
proto.identity.BusinessInfo.prototype.setMobilenumber = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string OrgID = 11;
 * @return {string}
 */
proto.identity.BusinessInfo.prototype.getOrgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.BusinessInfo} returns this
 */
proto.identity.BusinessInfo.prototype.setOrgid = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string District = 12;
 * @return {string}
 */
proto.identity.BusinessInfo.prototype.getDistrict = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.BusinessInfo} returns this
 */
proto.identity.BusinessInfo.prototype.setDistrict = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string SubDistrict = 13;
 * @return {string}
 */
proto.identity.BusinessInfo.prototype.getSubdistrict = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.BusinessInfo} returns this
 */
proto.identity.BusinessInfo.prototype.setSubdistrict = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional bool Enabled = 14;
 * @return {boolean}
 */
proto.identity.BusinessInfo.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.identity.BusinessInfo} returns this
 */
proto.identity.BusinessInfo.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};


/**
 * optional bool SupportRetries = 15;
 * @return {boolean}
 */
proto.identity.BusinessInfo.prototype.getSupportretries = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.identity.BusinessInfo} returns this
 */
proto.identity.BusinessInfo.prototype.setSupportretries = function(value) {
  return jspb.Message.setProto3BooleanField(this, 15, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.identity.Institution.prototype.toObject = function(opt_includeInstance) {
  return proto.identity.Institution.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.identity.Institution} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.Institution.toObject = function(includeInstance, msg) {
  var f, obj = {
    product: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    title: jspb.Message.getFieldWithDefault(msg, 3, ""),
    institutioncode: jspb.Message.getFieldWithDefault(msg, 4, 0),
    status: jspb.Message.getFieldWithDefault(msg, 5, 0),
    country: jspb.Message.getFieldWithDefault(msg, 6, ""),
    productstatus: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.identity.Institution}
 */
proto.identity.Institution.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.identity.Institution;
  return proto.identity.Institution.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.identity.Institution} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.identity.Institution}
 */
proto.identity.Institution.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.identity.Product} */ (reader.readEnum());
      msg.setProduct(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 4:
      var value = /** @type {!proto.identity.BankCode} */ (reader.readEnum());
      msg.setInstitutioncode(value);
      break;
    case 5:
      var value = /** @type {!proto.identity.ProductStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    case 7:
      var value = /** @type {!proto.identity.ProductStatus} */ (reader.readEnum());
      msg.setProductstatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.identity.Institution.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.identity.Institution.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.identity.Institution} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.Institution.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProduct();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getInstitutioncode();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getProductstatus();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
};


/**
 * optional Product Product = 1;
 * @return {!proto.identity.Product}
 */
proto.identity.Institution.prototype.getProduct = function() {
  return /** @type {!proto.identity.Product} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.identity.Product} value
 * @return {!proto.identity.Institution} returns this
 */
proto.identity.Institution.prototype.setProduct = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string Name = 2;
 * @return {string}
 */
proto.identity.Institution.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Institution} returns this
 */
proto.identity.Institution.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Title = 3;
 * @return {string}
 */
proto.identity.Institution.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Institution} returns this
 */
proto.identity.Institution.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional BankCode InstitutionCode = 4;
 * @return {!proto.identity.BankCode}
 */
proto.identity.Institution.prototype.getInstitutioncode = function() {
  return /** @type {!proto.identity.BankCode} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.identity.BankCode} value
 * @return {!proto.identity.Institution} returns this
 */
proto.identity.Institution.prototype.setInstitutioncode = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional ProductStatus Status = 5;
 * @return {!proto.identity.ProductStatus}
 */
proto.identity.Institution.prototype.getStatus = function() {
  return /** @type {!proto.identity.ProductStatus} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.identity.ProductStatus} value
 * @return {!proto.identity.Institution} returns this
 */
proto.identity.Institution.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional string Country = 6;
 * @return {string}
 */
proto.identity.Institution.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Institution} returns this
 */
proto.identity.Institution.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional ProductStatus ProductStatus = 7;
 * @return {!proto.identity.ProductStatus}
 */
proto.identity.Institution.prototype.getProductstatus = function() {
  return /** @type {!proto.identity.ProductStatus} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.identity.ProductStatus} value
 * @return {!proto.identity.Institution} returns this
 */
proto.identity.Institution.prototype.setProductstatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.identity.ProductStatusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.identity.ProductStatusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.identity.ProductStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.ProductStatusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    country: jspb.Message.getFieldWithDefault(msg, 1, ""),
    institutioncode: jspb.Message.getFieldWithDefault(msg, 2, 0),
    product: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.identity.ProductStatusRequest}
 */
proto.identity.ProductStatusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.identity.ProductStatusRequest;
  return proto.identity.ProductStatusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.identity.ProductStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.identity.ProductStatusRequest}
 */
proto.identity.ProductStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    case 2:
      var value = /** @type {!proto.identity.BankCode} */ (reader.readEnum());
      msg.setInstitutioncode(value);
      break;
    case 3:
      var value = /** @type {!proto.identity.Product} */ (reader.readEnum());
      msg.setProduct(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.identity.ProductStatusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.identity.ProductStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.identity.ProductStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.ProductStatusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getInstitutioncode();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getProduct();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional string Country = 1;
 * @return {string}
 */
proto.identity.ProductStatusRequest.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.ProductStatusRequest} returns this
 */
proto.identity.ProductStatusRequest.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional BankCode InstitutionCode = 2;
 * @return {!proto.identity.BankCode}
 */
proto.identity.ProductStatusRequest.prototype.getInstitutioncode = function() {
  return /** @type {!proto.identity.BankCode} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.identity.BankCode} value
 * @return {!proto.identity.ProductStatusRequest} returns this
 */
proto.identity.ProductStatusRequest.prototype.setInstitutioncode = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional Product Product = 3;
 * @return {!proto.identity.Product}
 */
proto.identity.ProductStatusRequest.prototype.getProduct = function() {
  return /** @type {!proto.identity.Product} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.identity.Product} value
 * @return {!proto.identity.ProductStatusRequest} returns this
 */
proto.identity.ProductStatusRequest.prototype.setProduct = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.identity.ProductStatusResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.identity.ProductStatusResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.identity.ProductStatusResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.identity.ProductStatusResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.ProductStatusResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    institutionsList: jspb.Message.toObjectList(msg.getInstitutionsList(),
    proto.identity.Institution.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.identity.ProductStatusResponse}
 */
proto.identity.ProductStatusResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.identity.ProductStatusResponse;
  return proto.identity.ProductStatusResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.identity.ProductStatusResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.identity.ProductStatusResponse}
 */
proto.identity.ProductStatusResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.identity.Institution;
      reader.readMessage(value,proto.identity.Institution.deserializeBinaryFromReader);
      msg.addInstitutions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.identity.ProductStatusResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.identity.ProductStatusResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.identity.ProductStatusResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.ProductStatusResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInstitutionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.identity.Institution.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Institution Institutions = 1;
 * @return {!Array<!proto.identity.Institution>}
 */
proto.identity.ProductStatusResponse.prototype.getInstitutionsList = function() {
  return /** @type{!Array<!proto.identity.Institution>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.identity.Institution, 1));
};


/**
 * @param {!Array<!proto.identity.Institution>} value
 * @return {!proto.identity.ProductStatusResponse} returns this
*/
proto.identity.ProductStatusResponse.prototype.setInstitutionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.identity.Institution=} opt_value
 * @param {number=} opt_index
 * @return {!proto.identity.Institution}
 */
proto.identity.ProductStatusResponse.prototype.addInstitutions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.identity.Institution, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.identity.ProductStatusResponse} returns this
 */
proto.identity.ProductStatusResponse.prototype.clearInstitutionsList = function() {
  return this.setInstitutionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.identity.ResourcePermissionSet.prototype.toObject = function(opt_includeInstance) {
  return proto.identity.ResourcePermissionSet.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.identity.ResourcePermissionSet} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.ResourcePermissionSet.toObject = function(includeInstance, msg) {
  var f, obj = {
    resource: jspb.Message.getFieldWithDefault(msg, 1, ""),
    description: jspb.Message.getFieldWithDefault(msg, 2, ""),
    action: jspb.Message.getFieldWithDefault(msg, 3, ""),
    product: jspb.Message.getFieldWithDefault(msg, 4, 0),
    endpoints: jspb.Message.getFieldWithDefault(msg, 5, ""),
    scope: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.identity.ResourcePermissionSet}
 */
proto.identity.ResourcePermissionSet.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.identity.ResourcePermissionSet;
  return proto.identity.ResourcePermissionSet.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.identity.ResourcePermissionSet} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.identity.ResourcePermissionSet}
 */
proto.identity.ResourcePermissionSet.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setResource(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAction(value);
      break;
    case 4:
      var value = /** @type {!proto.identity.Product} */ (reader.readEnum());
      msg.setProduct(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setEndpoints(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setScope(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.identity.ResourcePermissionSet.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.identity.ResourcePermissionSet.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.identity.ResourcePermissionSet} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.ResourcePermissionSet.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResource();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAction();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getProduct();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getEndpoints();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getScope();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string Resource = 1;
 * @return {string}
 */
proto.identity.ResourcePermissionSet.prototype.getResource = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.ResourcePermissionSet} returns this
 */
proto.identity.ResourcePermissionSet.prototype.setResource = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Description = 2;
 * @return {string}
 */
proto.identity.ResourcePermissionSet.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.ResourcePermissionSet} returns this
 */
proto.identity.ResourcePermissionSet.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Action = 3;
 * @return {string}
 */
proto.identity.ResourcePermissionSet.prototype.getAction = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.ResourcePermissionSet} returns this
 */
proto.identity.ResourcePermissionSet.prototype.setAction = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional Product Product = 4;
 * @return {!proto.identity.Product}
 */
proto.identity.ResourcePermissionSet.prototype.getProduct = function() {
  return /** @type {!proto.identity.Product} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.identity.Product} value
 * @return {!proto.identity.ResourcePermissionSet} returns this
 */
proto.identity.ResourcePermissionSet.prototype.setProduct = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string Endpoints = 5;
 * @return {string}
 */
proto.identity.ResourcePermissionSet.prototype.getEndpoints = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.ResourcePermissionSet} returns this
 */
proto.identity.ResourcePermissionSet.prototype.setEndpoints = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string Scope = 6;
 * @return {string}
 */
proto.identity.ResourcePermissionSet.prototype.getScope = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.ResourcePermissionSet} returns this
 */
proto.identity.ResourcePermissionSet.prototype.setScope = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.identity.Permission.prototype.toObject = function(opt_includeInstance) {
  return proto.identity.Permission.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.identity.Permission} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.Permission.toObject = function(includeInstance, msg) {
  var f, obj = {
    endpoint: jspb.Message.getFieldWithDefault(msg, 1, ""),
    description: jspb.Message.getFieldWithDefault(msg, 2, ""),
    scope: jspb.Message.getFieldWithDefault(msg, 3, ""),
    key: jspb.Message.getFieldWithDefault(msg, 4, 0),
    id: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.identity.Permission}
 */
proto.identity.Permission.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.identity.Permission;
  return proto.identity.Permission.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.identity.Permission} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.identity.Permission}
 */
proto.identity.Permission.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEndpoint(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setScope(value);
      break;
    case 4:
      var value = /** @type {!proto.identity.PermissionSet} */ (reader.readEnum());
      msg.setKey(value);
      break;
    case 5:
      var value = /** @type {!proto.identity.PermissionSet} */ (reader.readEnum());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.identity.Permission.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.identity.Permission.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.identity.Permission} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.Permission.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEndpoint();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getScope();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getKey();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getId();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
};


/**
 * optional string Endpoint = 1;
 * @return {string}
 */
proto.identity.Permission.prototype.getEndpoint = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Permission} returns this
 */
proto.identity.Permission.prototype.setEndpoint = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Description = 2;
 * @return {string}
 */
proto.identity.Permission.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Permission} returns this
 */
proto.identity.Permission.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Scope = 3;
 * @return {string}
 */
proto.identity.Permission.prototype.getScope = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Permission} returns this
 */
proto.identity.Permission.prototype.setScope = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional PermissionSet Key = 4;
 * @return {!proto.identity.PermissionSet}
 */
proto.identity.Permission.prototype.getKey = function() {
  return /** @type {!proto.identity.PermissionSet} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.identity.PermissionSet} value
 * @return {!proto.identity.Permission} returns this
 */
proto.identity.Permission.prototype.setKey = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional PermissionSet ID = 5;
 * @return {!proto.identity.PermissionSet}
 */
proto.identity.Permission.prototype.getId = function() {
  return /** @type {!proto.identity.PermissionSet} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.identity.PermissionSet} value
 * @return {!proto.identity.Permission} returns this
 */
proto.identity.Permission.prototype.setId = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.identity.Role.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.identity.Role.prototype.toObject = function(opt_includeInstance) {
  return proto.identity.Role.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.identity.Role} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.Role.toObject = function(includeInstance, msg) {
  var f, obj = {
    permissionsList: jspb.Message.toObjectList(msg.getPermissionsList(),
    proto.identity.Permission.toObject, includeInstance),
    businessid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    description: jspb.Message.getFieldWithDefault(msg, 4, ""),
    id: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.identity.Role}
 */
proto.identity.Role.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.identity.Role;
  return proto.identity.Role.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.identity.Role} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.identity.Role}
 */
proto.identity.Role.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.identity.Permission;
      reader.readMessage(value,proto.identity.Permission.deserializeBinaryFromReader);
      msg.addPermissions(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBusinessid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.identity.Role.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.identity.Role.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.identity.Role} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.Role.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPermissionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.identity.Permission.serializeBinaryToWriter
    );
  }
  f = message.getBusinessid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * repeated Permission Permissions = 1;
 * @return {!Array<!proto.identity.Permission>}
 */
proto.identity.Role.prototype.getPermissionsList = function() {
  return /** @type{!Array<!proto.identity.Permission>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.identity.Permission, 1));
};


/**
 * @param {!Array<!proto.identity.Permission>} value
 * @return {!proto.identity.Role} returns this
*/
proto.identity.Role.prototype.setPermissionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.identity.Permission=} opt_value
 * @param {number=} opt_index
 * @return {!proto.identity.Permission}
 */
proto.identity.Role.prototype.addPermissions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.identity.Permission, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.identity.Role} returns this
 */
proto.identity.Role.prototype.clearPermissionsList = function() {
  return this.setPermissionsList([]);
};


/**
 * optional string BusinessID = 2;
 * @return {string}
 */
proto.identity.Role.prototype.getBusinessid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Role} returns this
 */
proto.identity.Role.prototype.setBusinessid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Name = 3;
 * @return {string}
 */
proto.identity.Role.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Role} returns this
 */
proto.identity.Role.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string Description = 4;
 * @return {string}
 */
proto.identity.Role.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Role} returns this
 */
proto.identity.Role.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string ID = 5;
 * @return {string}
 */
proto.identity.Role.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.Role} returns this
 */
proto.identity.Role.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.identity.NotificationSetting.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.identity.NotificationSetting.prototype.toObject = function(opt_includeInstance) {
  return proto.identity.NotificationSetting.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.identity.NotificationSetting} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.NotificationSetting.toObject = function(includeInstance, msg) {
  var f, obj = {
    key: jspb.Message.getFieldWithDefault(msg, 1, 0),
    title: jspb.Message.getFieldWithDefault(msg, 2, ""),
    isenabled: jspb.Message.getFieldWithDefault(msg, 3, ""),
    recipientsList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
    productkey: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.identity.NotificationSetting}
 */
proto.identity.NotificationSetting.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.identity.NotificationSetting;
  return proto.identity.NotificationSetting.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.identity.NotificationSetting} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.identity.NotificationSetting}
 */
proto.identity.NotificationSetting.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.identity.NotificationSettingKey} */ (reader.readEnum());
      msg.setKey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setIsenabled(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addRecipients(value);
      break;
    case 5:
      var value = /** @type {!proto.identity.Product} */ (reader.readEnum());
      msg.setProductkey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.identity.NotificationSetting.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.identity.NotificationSetting.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.identity.NotificationSetting} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.NotificationSetting.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKey();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIsenabled();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRecipientsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getProductkey();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
};


/**
 * optional NotificationSettingKey Key = 1;
 * @return {!proto.identity.NotificationSettingKey}
 */
proto.identity.NotificationSetting.prototype.getKey = function() {
  return /** @type {!proto.identity.NotificationSettingKey} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.identity.NotificationSettingKey} value
 * @return {!proto.identity.NotificationSetting} returns this
 */
proto.identity.NotificationSetting.prototype.setKey = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string Title = 2;
 * @return {string}
 */
proto.identity.NotificationSetting.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.NotificationSetting} returns this
 */
proto.identity.NotificationSetting.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string IsEnabled = 3;
 * @return {string}
 */
proto.identity.NotificationSetting.prototype.getIsenabled = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.identity.NotificationSetting} returns this
 */
proto.identity.NotificationSetting.prototype.setIsenabled = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated string Recipients = 4;
 * @return {!Array<string>}
 */
proto.identity.NotificationSetting.prototype.getRecipientsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.identity.NotificationSetting} returns this
 */
proto.identity.NotificationSetting.prototype.setRecipientsList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.identity.NotificationSetting} returns this
 */
proto.identity.NotificationSetting.prototype.addRecipients = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.identity.NotificationSetting} returns this
 */
proto.identity.NotificationSetting.prototype.clearRecipientsList = function() {
  return this.setRecipientsList([]);
};


/**
 * optional Product ProductKey = 5;
 * @return {!proto.identity.Product}
 */
proto.identity.NotificationSetting.prototype.getProductkey = function() {
  return /** @type {!proto.identity.Product} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.identity.Product} value
 * @return {!proto.identity.NotificationSetting} returns this
 */
proto.identity.NotificationSetting.prototype.setProductkey = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.identity.Intermediary.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.identity.Intermediary.prototype.toObject = function(opt_includeInstance) {
  return proto.identity.Intermediary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.identity.Intermediary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.Intermediary.toObject = function(includeInstance, msg) {
  var f, obj = {
    lastpage: jspb.Message.getFieldWithDefault(msg, 1, 0),
    productList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    transactionvolume: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.identity.Intermediary}
 */
proto.identity.Intermediary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.identity.Intermediary;
  return proto.identity.Intermediary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.identity.Intermediary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.identity.Intermediary}
 */
proto.identity.Intermediary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLastpage(value);
      break;
    case 2:
      var value = /** @type {!Array<!proto.identity.Product>} */ (reader.readPackedEnum());
      msg.setProductList(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTransactionvolume(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.identity.Intermediary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.identity.Intermediary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.identity.Intermediary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.Intermediary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLastpage();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getProductList();
  if (f.length > 0) {
    writer.writePackedEnum(
      2,
      f
    );
  }
  f = message.getTransactionvolume();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional int32 LastPage = 1;
 * @return {number}
 */
proto.identity.Intermediary.prototype.getLastpage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.identity.Intermediary} returns this
 */
proto.identity.Intermediary.prototype.setLastpage = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated Product Product = 2;
 * @return {!Array<!proto.identity.Product>}
 */
proto.identity.Intermediary.prototype.getProductList = function() {
  return /** @type {!Array<!proto.identity.Product>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<!proto.identity.Product>} value
 * @return {!proto.identity.Intermediary} returns this
 */
proto.identity.Intermediary.prototype.setProductList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {!proto.identity.Product} value
 * @param {number=} opt_index
 * @return {!proto.identity.Intermediary} returns this
 */
proto.identity.Intermediary.prototype.addProduct = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.identity.Intermediary} returns this
 */
proto.identity.Intermediary.prototype.clearProductList = function() {
  return this.setProductList([]);
};


/**
 * optional int32 TransactionVolume = 3;
 * @return {number}
 */
proto.identity.Intermediary.prototype.getTransactionvolume = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.identity.Intermediary} returns this
 */
proto.identity.Intermediary.prototype.setTransactionvolume = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.identity.TutorialSteps.prototype.toObject = function(opt_includeInstance) {
  return proto.identity.TutorialSteps.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.identity.TutorialSteps} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.TutorialSteps.toObject = function(includeInstance, msg) {
  var f, obj = {
    createapikey: jspb.Message.getFieldWithDefault(msg, 1, 0),
    setupdestinationaccountdirect: jspb.Message.getFieldWithDefault(msg, 2, 0),
    setupsourceaccountdisburse: jspb.Message.getFieldWithDefault(msg, 3, 0),
    setupbeneficiarydisburse: jspb.Message.getFieldWithDefault(msg, 4, 0),
    setuppostmandirect: jspb.Message.getFieldWithDefault(msg, 5, 0),
    setuppostmandisburse: jspb.Message.getFieldWithDefault(msg, 6, 0),
    setuppostmanstatement: jspb.Message.getFieldWithDefault(msg, 7, 0),
    setuppostmanao: jspb.Message.getFieldWithDefault(msg, 8, 0),
    createstaticlinkstatement: jspb.Message.getFieldWithDefault(msg, 9, 0),
    completedirecttransaction: jspb.Message.getFieldWithDefault(msg, 10, 0),
    completedisbursetransaction: jspb.Message.getFieldWithDefault(msg, 11, 0),
    completedisbursetransactionapi: jspb.Message.getFieldWithDefault(msg, 12, 0),
    completestatementtransaction: jspb.Message.getFieldWithDefault(msg, 13, 0),
    completestatementtransactionapi: jspb.Message.getFieldWithDefault(msg, 14, 0),
    completeaotransactionapi: jspb.Message.getFieldWithDefault(msg, 15, 0),
    testmethoddirectapi: jspb.Message.getFieldWithDefault(msg, 16, 0),
    testmethoddisburseapi: jspb.Message.getFieldWithDefault(msg, 17, 0),
    testmethodstatementapi: jspb.Message.getFieldWithDefault(msg, 18, 0),
    testmethodaoapi: jspb.Message.getFieldWithDefault(msg, 19, 0),
    createapikeydirect: jspb.Message.getFieldWithDefault(msg, 20, 0),
    createapikeydisburse: jspb.Message.getFieldWithDefault(msg, 21, 0),
    createapikeystatement: jspb.Message.getFieldWithDefault(msg, 22, 0),
    createapikeyao: jspb.Message.getFieldWithDefault(msg, 23, 0),
    createsinglepayoutdisburse: jspb.Message.getFieldWithDefault(msg, 24, 0),
    completetapflowstatement: jspb.Message.getFieldWithDefault(msg, 25, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.identity.TutorialSteps}
 */
proto.identity.TutorialSteps.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.identity.TutorialSteps;
  return proto.identity.TutorialSteps.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.identity.TutorialSteps} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.identity.TutorialSteps}
 */
proto.identity.TutorialSteps.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.identity.TutorialStepStatus} */ (reader.readEnum());
      msg.setCreateapikey(value);
      break;
    case 2:
      var value = /** @type {!proto.identity.TutorialStepStatus} */ (reader.readEnum());
      msg.setSetupdestinationaccountdirect(value);
      break;
    case 3:
      var value = /** @type {!proto.identity.TutorialStepStatus} */ (reader.readEnum());
      msg.setSetupsourceaccountdisburse(value);
      break;
    case 4:
      var value = /** @type {!proto.identity.TutorialStepStatus} */ (reader.readEnum());
      msg.setSetupbeneficiarydisburse(value);
      break;
    case 5:
      var value = /** @type {!proto.identity.TutorialStepStatus} */ (reader.readEnum());
      msg.setSetuppostmandirect(value);
      break;
    case 6:
      var value = /** @type {!proto.identity.TutorialStepStatus} */ (reader.readEnum());
      msg.setSetuppostmandisburse(value);
      break;
    case 7:
      var value = /** @type {!proto.identity.TutorialStepStatus} */ (reader.readEnum());
      msg.setSetuppostmanstatement(value);
      break;
    case 8:
      var value = /** @type {!proto.identity.TutorialStepStatus} */ (reader.readEnum());
      msg.setSetuppostmanao(value);
      break;
    case 9:
      var value = /** @type {!proto.identity.TutorialStepStatus} */ (reader.readEnum());
      msg.setCreatestaticlinkstatement(value);
      break;
    case 10:
      var value = /** @type {!proto.identity.TutorialStepStatus} */ (reader.readEnum());
      msg.setCompletedirecttransaction(value);
      break;
    case 11:
      var value = /** @type {!proto.identity.TutorialStepStatus} */ (reader.readEnum());
      msg.setCompletedisbursetransaction(value);
      break;
    case 12:
      var value = /** @type {!proto.identity.TutorialStepStatus} */ (reader.readEnum());
      msg.setCompletedisbursetransactionapi(value);
      break;
    case 13:
      var value = /** @type {!proto.identity.TutorialStepStatus} */ (reader.readEnum());
      msg.setCompletestatementtransaction(value);
      break;
    case 14:
      var value = /** @type {!proto.identity.TutorialStepStatus} */ (reader.readEnum());
      msg.setCompletestatementtransactionapi(value);
      break;
    case 15:
      var value = /** @type {!proto.identity.TutorialStepStatus} */ (reader.readEnum());
      msg.setCompleteaotransactionapi(value);
      break;
    case 16:
      var value = /** @type {!proto.identity.TutorialStepStatus} */ (reader.readEnum());
      msg.setTestmethoddirectapi(value);
      break;
    case 17:
      var value = /** @type {!proto.identity.TutorialStepStatus} */ (reader.readEnum());
      msg.setTestmethoddisburseapi(value);
      break;
    case 18:
      var value = /** @type {!proto.identity.TutorialStepStatus} */ (reader.readEnum());
      msg.setTestmethodstatementapi(value);
      break;
    case 19:
      var value = /** @type {!proto.identity.TutorialStepStatus} */ (reader.readEnum());
      msg.setTestmethodaoapi(value);
      break;
    case 20:
      var value = /** @type {!proto.identity.TutorialStepStatus} */ (reader.readEnum());
      msg.setCreateapikeydirect(value);
      break;
    case 21:
      var value = /** @type {!proto.identity.TutorialStepStatus} */ (reader.readEnum());
      msg.setCreateapikeydisburse(value);
      break;
    case 22:
      var value = /** @type {!proto.identity.TutorialStepStatus} */ (reader.readEnum());
      msg.setCreateapikeystatement(value);
      break;
    case 23:
      var value = /** @type {!proto.identity.TutorialStepStatus} */ (reader.readEnum());
      msg.setCreateapikeyao(value);
      break;
    case 24:
      var value = /** @type {!proto.identity.TutorialStepStatus} */ (reader.readEnum());
      msg.setCreatesinglepayoutdisburse(value);
      break;
    case 25:
      var value = /** @type {!proto.identity.TutorialStepStatus} */ (reader.readEnum());
      msg.setCompletetapflowstatement(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.identity.TutorialSteps.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.identity.TutorialSteps.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.identity.TutorialSteps} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.identity.TutorialSteps.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCreateapikey();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getSetupdestinationaccountdirect();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getSetupsourceaccountdisburse();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getSetupbeneficiarydisburse();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getSetuppostmandirect();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getSetuppostmandisburse();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getSetuppostmanstatement();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getSetuppostmanao();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getCreatestaticlinkstatement();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getCompletedirecttransaction();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getCompletedisbursetransaction();
  if (f !== 0.0) {
    writer.writeEnum(
      11,
      f
    );
  }
  f = message.getCompletedisbursetransactionapi();
  if (f !== 0.0) {
    writer.writeEnum(
      12,
      f
    );
  }
  f = message.getCompletestatementtransaction();
  if (f !== 0.0) {
    writer.writeEnum(
      13,
      f
    );
  }
  f = message.getCompletestatementtransactionapi();
  if (f !== 0.0) {
    writer.writeEnum(
      14,
      f
    );
  }
  f = message.getCompleteaotransactionapi();
  if (f !== 0.0) {
    writer.writeEnum(
      15,
      f
    );
  }
  f = message.getTestmethoddirectapi();
  if (f !== 0.0) {
    writer.writeEnum(
      16,
      f
    );
  }
  f = message.getTestmethoddisburseapi();
  if (f !== 0.0) {
    writer.writeEnum(
      17,
      f
    );
  }
  f = message.getTestmethodstatementapi();
  if (f !== 0.0) {
    writer.writeEnum(
      18,
      f
    );
  }
  f = message.getTestmethodaoapi();
  if (f !== 0.0) {
    writer.writeEnum(
      19,
      f
    );
  }
  f = message.getCreateapikeydirect();
  if (f !== 0.0) {
    writer.writeEnum(
      20,
      f
    );
  }
  f = message.getCreateapikeydisburse();
  if (f !== 0.0) {
    writer.writeEnum(
      21,
      f
    );
  }
  f = message.getCreateapikeystatement();
  if (f !== 0.0) {
    writer.writeEnum(
      22,
      f
    );
  }
  f = message.getCreateapikeyao();
  if (f !== 0.0) {
    writer.writeEnum(
      23,
      f
    );
  }
  f = message.getCreatesinglepayoutdisburse();
  if (f !== 0.0) {
    writer.writeEnum(
      24,
      f
    );
  }
  f = message.getCompletetapflowstatement();
  if (f !== 0.0) {
    writer.writeEnum(
      25,
      f
    );
  }
};


/**
 * optional TutorialStepStatus CreateAPIKey = 1;
 * @return {!proto.identity.TutorialStepStatus}
 */
proto.identity.TutorialSteps.prototype.getCreateapikey = function() {
  return /** @type {!proto.identity.TutorialStepStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.identity.TutorialStepStatus} value
 * @return {!proto.identity.TutorialSteps} returns this
 */
proto.identity.TutorialSteps.prototype.setCreateapikey = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional TutorialStepStatus SetupDestinationAccountDirect = 2;
 * @return {!proto.identity.TutorialStepStatus}
 */
proto.identity.TutorialSteps.prototype.getSetupdestinationaccountdirect = function() {
  return /** @type {!proto.identity.TutorialStepStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.identity.TutorialStepStatus} value
 * @return {!proto.identity.TutorialSteps} returns this
 */
proto.identity.TutorialSteps.prototype.setSetupdestinationaccountdirect = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional TutorialStepStatus SetupSourceAccountDisburse = 3;
 * @return {!proto.identity.TutorialStepStatus}
 */
proto.identity.TutorialSteps.prototype.getSetupsourceaccountdisburse = function() {
  return /** @type {!proto.identity.TutorialStepStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.identity.TutorialStepStatus} value
 * @return {!proto.identity.TutorialSteps} returns this
 */
proto.identity.TutorialSteps.prototype.setSetupsourceaccountdisburse = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional TutorialStepStatus SetupBeneficiaryDisburse = 4;
 * @return {!proto.identity.TutorialStepStatus}
 */
proto.identity.TutorialSteps.prototype.getSetupbeneficiarydisburse = function() {
  return /** @type {!proto.identity.TutorialStepStatus} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.identity.TutorialStepStatus} value
 * @return {!proto.identity.TutorialSteps} returns this
 */
proto.identity.TutorialSteps.prototype.setSetupbeneficiarydisburse = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional TutorialStepStatus SetupPostmanDirect = 5;
 * @return {!proto.identity.TutorialStepStatus}
 */
proto.identity.TutorialSteps.prototype.getSetuppostmandirect = function() {
  return /** @type {!proto.identity.TutorialStepStatus} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.identity.TutorialStepStatus} value
 * @return {!proto.identity.TutorialSteps} returns this
 */
proto.identity.TutorialSteps.prototype.setSetuppostmandirect = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional TutorialStepStatus SetupPostmanDisburse = 6;
 * @return {!proto.identity.TutorialStepStatus}
 */
proto.identity.TutorialSteps.prototype.getSetuppostmandisburse = function() {
  return /** @type {!proto.identity.TutorialStepStatus} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.identity.TutorialStepStatus} value
 * @return {!proto.identity.TutorialSteps} returns this
 */
proto.identity.TutorialSteps.prototype.setSetuppostmandisburse = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional TutorialStepStatus SetupPostmanStatement = 7;
 * @return {!proto.identity.TutorialStepStatus}
 */
proto.identity.TutorialSteps.prototype.getSetuppostmanstatement = function() {
  return /** @type {!proto.identity.TutorialStepStatus} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.identity.TutorialStepStatus} value
 * @return {!proto.identity.TutorialSteps} returns this
 */
proto.identity.TutorialSteps.prototype.setSetuppostmanstatement = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional TutorialStepStatus SetupPostmanAO = 8;
 * @return {!proto.identity.TutorialStepStatus}
 */
proto.identity.TutorialSteps.prototype.getSetuppostmanao = function() {
  return /** @type {!proto.identity.TutorialStepStatus} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.identity.TutorialStepStatus} value
 * @return {!proto.identity.TutorialSteps} returns this
 */
proto.identity.TutorialSteps.prototype.setSetuppostmanao = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional TutorialStepStatus CreateStaticLinkStatement = 9;
 * @return {!proto.identity.TutorialStepStatus}
 */
proto.identity.TutorialSteps.prototype.getCreatestaticlinkstatement = function() {
  return /** @type {!proto.identity.TutorialStepStatus} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.identity.TutorialStepStatus} value
 * @return {!proto.identity.TutorialSteps} returns this
 */
proto.identity.TutorialSteps.prototype.setCreatestaticlinkstatement = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional TutorialStepStatus CompleteDirectTransaction = 10;
 * @return {!proto.identity.TutorialStepStatus}
 */
proto.identity.TutorialSteps.prototype.getCompletedirecttransaction = function() {
  return /** @type {!proto.identity.TutorialStepStatus} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.identity.TutorialStepStatus} value
 * @return {!proto.identity.TutorialSteps} returns this
 */
proto.identity.TutorialSteps.prototype.setCompletedirecttransaction = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional TutorialStepStatus CompleteDisburseTransaction = 11;
 * @return {!proto.identity.TutorialStepStatus}
 */
proto.identity.TutorialSteps.prototype.getCompletedisbursetransaction = function() {
  return /** @type {!proto.identity.TutorialStepStatus} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {!proto.identity.TutorialStepStatus} value
 * @return {!proto.identity.TutorialSteps} returns this
 */
proto.identity.TutorialSteps.prototype.setCompletedisbursetransaction = function(value) {
  return jspb.Message.setProto3EnumField(this, 11, value);
};


/**
 * optional TutorialStepStatus CompleteDisburseTransactionAPI = 12;
 * @return {!proto.identity.TutorialStepStatus}
 */
proto.identity.TutorialSteps.prototype.getCompletedisbursetransactionapi = function() {
  return /** @type {!proto.identity.TutorialStepStatus} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {!proto.identity.TutorialStepStatus} value
 * @return {!proto.identity.TutorialSteps} returns this
 */
proto.identity.TutorialSteps.prototype.setCompletedisbursetransactionapi = function(value) {
  return jspb.Message.setProto3EnumField(this, 12, value);
};


/**
 * optional TutorialStepStatus CompleteStatementTransaction = 13;
 * @return {!proto.identity.TutorialStepStatus}
 */
proto.identity.TutorialSteps.prototype.getCompletestatementtransaction = function() {
  return /** @type {!proto.identity.TutorialStepStatus} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {!proto.identity.TutorialStepStatus} value
 * @return {!proto.identity.TutorialSteps} returns this
 */
proto.identity.TutorialSteps.prototype.setCompletestatementtransaction = function(value) {
  return jspb.Message.setProto3EnumField(this, 13, value);
};


/**
 * optional TutorialStepStatus CompleteStatementTransactionAPI = 14;
 * @return {!proto.identity.TutorialStepStatus}
 */
proto.identity.TutorialSteps.prototype.getCompletestatementtransactionapi = function() {
  return /** @type {!proto.identity.TutorialStepStatus} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {!proto.identity.TutorialStepStatus} value
 * @return {!proto.identity.TutorialSteps} returns this
 */
proto.identity.TutorialSteps.prototype.setCompletestatementtransactionapi = function(value) {
  return jspb.Message.setProto3EnumField(this, 14, value);
};


/**
 * optional TutorialStepStatus CompleteAOTransactionAPI = 15;
 * @return {!proto.identity.TutorialStepStatus}
 */
proto.identity.TutorialSteps.prototype.getCompleteaotransactionapi = function() {
  return /** @type {!proto.identity.TutorialStepStatus} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {!proto.identity.TutorialStepStatus} value
 * @return {!proto.identity.TutorialSteps} returns this
 */
proto.identity.TutorialSteps.prototype.setCompleteaotransactionapi = function(value) {
  return jspb.Message.setProto3EnumField(this, 15, value);
};


/**
 * optional TutorialStepStatus TestMethodDirectAPI = 16;
 * @return {!proto.identity.TutorialStepStatus}
 */
proto.identity.TutorialSteps.prototype.getTestmethoddirectapi = function() {
  return /** @type {!proto.identity.TutorialStepStatus} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {!proto.identity.TutorialStepStatus} value
 * @return {!proto.identity.TutorialSteps} returns this
 */
proto.identity.TutorialSteps.prototype.setTestmethoddirectapi = function(value) {
  return jspb.Message.setProto3EnumField(this, 16, value);
};


/**
 * optional TutorialStepStatus TestMethodDisburseAPI = 17;
 * @return {!proto.identity.TutorialStepStatus}
 */
proto.identity.TutorialSteps.prototype.getTestmethoddisburseapi = function() {
  return /** @type {!proto.identity.TutorialStepStatus} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {!proto.identity.TutorialStepStatus} value
 * @return {!proto.identity.TutorialSteps} returns this
 */
proto.identity.TutorialSteps.prototype.setTestmethoddisburseapi = function(value) {
  return jspb.Message.setProto3EnumField(this, 17, value);
};


/**
 * optional TutorialStepStatus TestMethodStatementAPI = 18;
 * @return {!proto.identity.TutorialStepStatus}
 */
proto.identity.TutorialSteps.prototype.getTestmethodstatementapi = function() {
  return /** @type {!proto.identity.TutorialStepStatus} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {!proto.identity.TutorialStepStatus} value
 * @return {!proto.identity.TutorialSteps} returns this
 */
proto.identity.TutorialSteps.prototype.setTestmethodstatementapi = function(value) {
  return jspb.Message.setProto3EnumField(this, 18, value);
};


/**
 * optional TutorialStepStatus TestMethodAOAPI = 19;
 * @return {!proto.identity.TutorialStepStatus}
 */
proto.identity.TutorialSteps.prototype.getTestmethodaoapi = function() {
  return /** @type {!proto.identity.TutorialStepStatus} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {!proto.identity.TutorialStepStatus} value
 * @return {!proto.identity.TutorialSteps} returns this
 */
proto.identity.TutorialSteps.prototype.setTestmethodaoapi = function(value) {
  return jspb.Message.setProto3EnumField(this, 19, value);
};


/**
 * optional TutorialStepStatus CreateAPIKeyDirect = 20;
 * @return {!proto.identity.TutorialStepStatus}
 */
proto.identity.TutorialSteps.prototype.getCreateapikeydirect = function() {
  return /** @type {!proto.identity.TutorialStepStatus} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {!proto.identity.TutorialStepStatus} value
 * @return {!proto.identity.TutorialSteps} returns this
 */
proto.identity.TutorialSteps.prototype.setCreateapikeydirect = function(value) {
  return jspb.Message.setProto3EnumField(this, 20, value);
};


/**
 * optional TutorialStepStatus CreateAPIKeyDisburse = 21;
 * @return {!proto.identity.TutorialStepStatus}
 */
proto.identity.TutorialSteps.prototype.getCreateapikeydisburse = function() {
  return /** @type {!proto.identity.TutorialStepStatus} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {!proto.identity.TutorialStepStatus} value
 * @return {!proto.identity.TutorialSteps} returns this
 */
proto.identity.TutorialSteps.prototype.setCreateapikeydisburse = function(value) {
  return jspb.Message.setProto3EnumField(this, 21, value);
};


/**
 * optional TutorialStepStatus CreateAPIKeyStatement = 22;
 * @return {!proto.identity.TutorialStepStatus}
 */
proto.identity.TutorialSteps.prototype.getCreateapikeystatement = function() {
  return /** @type {!proto.identity.TutorialStepStatus} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/**
 * @param {!proto.identity.TutorialStepStatus} value
 * @return {!proto.identity.TutorialSteps} returns this
 */
proto.identity.TutorialSteps.prototype.setCreateapikeystatement = function(value) {
  return jspb.Message.setProto3EnumField(this, 22, value);
};


/**
 * optional TutorialStepStatus CreateAPIKeyAO = 23;
 * @return {!proto.identity.TutorialStepStatus}
 */
proto.identity.TutorialSteps.prototype.getCreateapikeyao = function() {
  return /** @type {!proto.identity.TutorialStepStatus} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/**
 * @param {!proto.identity.TutorialStepStatus} value
 * @return {!proto.identity.TutorialSteps} returns this
 */
proto.identity.TutorialSteps.prototype.setCreateapikeyao = function(value) {
  return jspb.Message.setProto3EnumField(this, 23, value);
};


/**
 * optional TutorialStepStatus CreateSinglePayoutDisburse = 24;
 * @return {!proto.identity.TutorialStepStatus}
 */
proto.identity.TutorialSteps.prototype.getCreatesinglepayoutdisburse = function() {
  return /** @type {!proto.identity.TutorialStepStatus} */ (jspb.Message.getFieldWithDefault(this, 24, 0));
};


/**
 * @param {!proto.identity.TutorialStepStatus} value
 * @return {!proto.identity.TutorialSteps} returns this
 */
proto.identity.TutorialSteps.prototype.setCreatesinglepayoutdisburse = function(value) {
  return jspb.Message.setProto3EnumField(this, 24, value);
};


/**
 * optional TutorialStepStatus CompleteTapFlowStatement = 25;
 * @return {!proto.identity.TutorialStepStatus}
 */
proto.identity.TutorialSteps.prototype.getCompletetapflowstatement = function() {
  return /** @type {!proto.identity.TutorialStepStatus} */ (jspb.Message.getFieldWithDefault(this, 25, 0));
};


/**
 * @param {!proto.identity.TutorialStepStatus} value
 * @return {!proto.identity.TutorialSteps} returns this
 */
proto.identity.TutorialSteps.prototype.setCompletetapflowstatement = function(value) {
  return jspb.Message.setProto3EnumField(this, 25, value);
};


/**
 * @enum {number}
 */
proto.identity.Status = {
  UNKNOWN_STATUS: 0,
  SUCCESS: 1,
  FAILED: 2
};

/**
 * @enum {number}
 */
proto.identity.NotificationServiceChannel = {
  UNKNOWN_CHANNEL: 0,
  SMS: 1,
  EMAIL: 2
};

/**
 * @enum {number}
 */
proto.identity.OrderBy = {
  DATE_DESCENDING: 0,
  DATE_ASCENDING: 1,
  NAME_DESCENDING: 2,
  NAME_ASCENDING: 3
};

/**
 * @enum {number}
 */
proto.identity.Product = {
  UNKNOWN: 0,
  ACCOUNT_OPENING: 1,
  CONTROL_CENTER: 2,
  DIRECT: 3,
  DISBURSE: 4,
  STATEMENT: 5,
  BALANCE: 6,
  MARKETPLACE: 7,
  VIRTUAL_ACCOUNT: 8,
  STATUS: 9
};

/**
 * @enum {number}
 */
proto.identity.CountryISO3166 = {
  UNKNOWN: 0,
  ID: 1,
  PH: 2,
  TH: 3,
  MY: 4,
  SG: 5,
  VN: 6,
  AU: 7,
  AT: 8,
  AZ: 9,
  AL: 10,
  DZ: 11,
  AS: 12,
  AI: 13,
  AO: 14,
  AD: 15,
  AQ: 16,
  AG: 17,
  AN: 18,
  AE: 19,
  AR: 20,
  AM: 21,
  AW: 22,
  AF: 23,
  BS: 24,
  BD: 25,
  BB: 26,
  BH: 27,
  BY: 28,
  BZ: 29,
  BE: 30,
  BJ: 31,
  BM: 32,
  BG: 33,
  BO: 34,
  BA: 35,
  BW: 36,
  BR: 37,
  IO: 38,
  BN: 39,
  BF: 40,
  BI: 41,
  BT: 42,
  VU: 43,
  VA: 44,
  GB: 45,
  HU: 46,
  VE: 47,
  VG: 48,
  VI: 49,
  TL: 50,
  GA: 51,
  HT: 52,
  GY: 53,
  GM: 54,
  GH: 55,
  GP: 56,
  GT: 57,
  GN: 58,
  GW: 59,
  DE: 60,
  GI: 61,
  HN: 62,
  HK: 63,
  GD: 64,
  GL: 65,
  GR: 66,
  GE: 67,
  GU: 68,
  DK: 69,
  CD: 70,
  DJ: 71,
  DM: 72,
  DO: 73,
  EG: 74,
  ZM: 75,
  EH: 76,
  ZW: 77,
  IL: 78,
  IN: 79,
  JO: 80,
  IQ: 81,
  IR: 82,
  IE: 83,
  IS: 84,
  ES: 85,
  IT: 86,
  YE: 87,
  KZ: 88,
  KY: 89,
  KH: 90,
  CM: 91,
  CA: 92,
  QA: 93,
  KE: 94,
  CY: 95,
  KI: 96,
  CN: 97,
  CC: 98,
  CO: 99,
  KM: 100,
  CG: 101,
  KP: 102,
  KR: 103,
  CR: 104,
  CI: 105,
  CU: 106,
  KW: 107,
  KG: 108,
  LA: 109,
  LV: 110,
  LS: 111,
  LR: 112,
  LB: 113,
  LY: 114,
  LT: 115,
  LI: 116,
  LU: 117,
  MU: 118,
  MR: 119,
  MG: 120,
  YT: 121,
  MO: 122,
  MK: 123,
  MW: 124,
  ML: 125,
  MV: 126,
  MT: 127,
  MP: 128,
  MA: 129,
  MQ: 130,
  MH: 131,
  MX: 132,
  FM: 133,
  MZ: 134,
  MD: 135,
  MC: 136,
  MN: 137,
  MS: 138,
  MM: 139,
  NA: 140,
  NR: 141,
  NP: 142,
  NE: 143,
  NG: 144,
  NL: 145,
  NI: 146,
  NU: 147,
  NZ: 148,
  NC: 149,
  NO: 150,
  OM: 151,
  BV: 152,
  IM: 153,
  NF: 154,
  PN: 155,
  CX: 156,
  SH: 157,
  WF: 158,
  HM: 159,
  CV: 160,
  CK: 161,
  WS: 162,
  SJ: 163,
  TC: 164,
  UM: 165,
  PK: 166,
  PW: 167,
  PS: 168,
  PA: 169,
  PG: 170,
  PY: 171,
  PE: 172,
  PL: 173,
  PT: 174,
  PR: 175,
  RE: 176,
  RU: 177,
  RW: 178,
  RO: 179,
  SV: 180,
  SM: 181,
  ST: 182,
  SA: 183,
  SZ: 184,
  SC: 185,
  SN: 186,
  PM: 187,
  VC: 188,
  KN: 189,
  LC: 190,
  SY: 191,
  SK: 192,
  SI: 193,
  US: 194,
  SB: 195,
  SO: 196,
  SD: 197,
  SR: 198,
  SL: 199,
  TJ: 200,
  TW: 201,
  TZ: 202,
  TG: 203,
  TK: 204,
  TO: 205,
  TT: 206,
  TV: 207,
  TN: 208,
  TM: 209,
  TR: 210,
  UG: 211,
  UZ: 212,
  UA: 213,
  UY: 214,
  FO: 215,
  FJ: 216,
  FI: 217,
  FK: 218,
  FR: 219,
  GF: 220,
  PF: 221,
  TF: 222,
  HR: 223,
  CF: 224,
  TD: 225,
  CZ: 226,
  CL: 227,
  CH: 228,
  SE: 229,
  LK: 230,
  EC: 231,
  GQ: 232,
  ER: 233,
  EE: 234,
  ET: 235,
  ZA: 236,
  YU: 237,
  GS: 238,
  JM: 239,
  ME: 240,
  BL: 241,
  SX: 242,
  RS: 243,
  AX: 244,
  BQ: 245,
  GG: 246,
  JE: 247,
  CW: 248,
  MF: 249,
  SS: 250,
  JP: 251,
  XK: 252
};

/**
 * @enum {number}
 */
proto.identity.KYCStatus = {
  UNKNOWN_KYCSTATUS: 0,
  NOT_APPLYING: 1,
  PENDING: 2,
  APPROVE: 3,
  NOT_APPROVE: 4,
  RESUBMISSION: 5
};

/**
 * @enum {number}
 */
proto.identity.OrgType = {
  UNKNOWN_ORGTYPE: 0,
  NOT_SET: 1,
  INDIVIDUAL: 2,
  COMPANY: 3
};

/**
 * @enum {number}
 */
proto.identity.DomicileType = {
  UNKNOWN_DOMICILETYPE: 0,
  LOCAL: 1,
  FOREIGN: 2
};

/**
 * @enum {number}
 */
proto.identity.PICType = {
  UNKNOWN_PIC: 0,
  AUTHORIZED_SIGNATORY: 1,
  BILLING: 2,
  BCA_PROJECT_MANAGER: 3,
  BCA_API_TRANSACTION_FACILITIES: 4,
  BCA_API_FACILITIES_PASSWORD: 5,
  BCA_API_FACILITIES_COMPLAINT_HANDLING: 6
};

/**
 * @enum {number}
 */
proto.identity.PartnerKycStatus = {
  UNKNOWN_PARTNERKYCSTATUS: 0,
  DRAFT_PARTNERKYCSTATUS: 1,
  SUBMITTED_PARTNERKYCSTATUS: 2,
  APPROVED_PARTNERKYCSTATUS: 3,
  DECLINED_PARTNERKYCSTATUS: 4,
  DELETED_PARTNERKYCSTATUS: 5
};

/**
 * @enum {number}
 */
proto.identity.KycPartner = {
  UNKNOWN_KYCPARTNER: 0,
  BRANKAS_GO_LIVE: 1,
  BCA: 2,
  PERMATA: 3,
  GCASH: 4
};

/**
 * @enum {number}
 */
proto.identity.PermataKycStatus = {
  UNKNOWN_PERMATAKYCSTATUS: 0,
  DRAFT_PERMATAKYCSTATUS: 1,
  SUBMITTED_PERMATAKYCSTATUS: 2,
  APPROVED_PERMATAKYCSTATUS: 3,
  DECLINED_PERMATAKYCSTATUS: 4,
  DELETED_PERMATAKYCSTATUS: 5
};

/**
 * @enum {number}
 */
proto.identity.OrgActivePeriod = {
  UNKNOWN_ORGACTIVEPERIOD: 0,
  YEARLESS1: 1,
  YEAR1TO3: 2,
  YEAR3TO5: 3,
  YEAREXCEED5: 4
};

/**
 * @enum {number}
 */
proto.identity.IDType = {
  UNKNOWN_IDTYPE: 0,
  KTP: 1,
  DRIVERLICENSE: 2,
  PASSPORT: 3
};

/**
 * @enum {number}
 */
proto.identity.PermissionSet = {
  UNKNOWN_PERMISSIONSET: 0,
  APIKEY_CREATE: 1,
  APIKEY_READ: 2,
  APIKEY_DELETE: 3,
  USERS_CREATE: 4,
  USERS_READ: 5,
  USERS_DELETE: 6,
  USERS_UPDATE: 7,
  TRANSACTIONS_READ: 8,
  TRANSACTIONS_CREATE: 9,
  TRANSACTIONS_UPDATE: 10,
  BUSINESS_UPDATE: 11,
  BUSINESS_READ: 12,
  DESTINATIONACCOUNT_CREATE: 13,
  DESTINATIONACCOUNT_READ: 14,
  CALLBACKS_ALL: 15,
  NOTIFICATIONSETTINGS_ALL: 16,
  TAPCUSTOMIZATION_ALL: 17,
  KYC_ALL: 18,
  DOWNLOADREPORT_ALL: 19,
  DEFAULTSETTINGS_ALL: 20,
  DESTINATIONACCOUNT_DELETE: 21,
  SOURCEACCOUNT_CREATE: 22,
  SOURCEACCOUNT_READ: 23,
  SOURCEACCOUNT_DELETE: 24,
  VIRTUALACCOUNT_CREATE: 25,
  VIRTUALACCOUNT_READ: 26,
  VIRTUALACCOUNT_UPDATE: 27,
  VIRTUALACCOUNT_DELETE: 28
};

/**
 * @enum {number}
 */
proto.identity.ProductStatus = {
  UNKNOWN_PRODUCT_STATUS: 0,
  ENABLED: 1,
  DISABLED: 2,
  PARTIAL: 3
};

/**
 * @enum {number}
 */
proto.identity.NotificationSettingKey = {
  UNKNOWN_NOTIFICATION_SETTING_KEY: 0,
  STATEMENT_TRANSACTION_SUCCESS: 1,
  DIRECT_TRANSACTION_FLAGGED: 2,
  DISBURSE_PAYOUT_WAITING: 3,
  DISBURSE_PAYOUT_PROCESSED: 4,
  DISBURSE_PAYOUT_REJECTED: 5,
  DISBURSE_SINGLEPAYOUT_PROCESSED: 6
};

/**
 * @enum {number}
 */
proto.identity.BankCode = {
  UNKNOWN_BANK: 0,
  PRODUCT: 1,
  DUMMY_BANK_PERSONAL: 261,
  BCA_PERSONAL: 258,
  BCA_CORPORATE: 514,
  BDO_PERSONAL: 262,
  BNI_PERSONAL: 259,
  BNI_CORPORATE: 559,
  BPI_PERSONAL: 263,
  BPI_CORPORATE: 264,
  BRI_PERSONAL: 260,
  BRI_CORPORATE: 424,
  BTN_PERSONAL: 267,
  CIMB_PERSONAL: 268,
  CLRB_PERSONAL: 411,
  DANAMON_PERSONAL: 402,
  EASTWEST_PERSONAL: 19,
  GCASH_PERSONAL: 20,
  GOPAY_PERSONAL: 21,
  JAGO_PERSONAL: 401,
  KASIKORNBANK_PERSONAL: 405,
  KOMO_PERSONAL: 18,
  LANDBANK_PERSONAL: 266,
  MANDIRI_PERSONAL: 257,
  MANDIRI_CORPORATE: 415,
  METROBANK_PERSONAL: 408,
  NETBANK_PERSONAL: 271,
  NETBANK_CORPORATE: 272,
  OVO_PERSONAL: 22,
  PERMATA_PERSONAL: 265,
  PERMATA_CORPORATE: 416,
  PNB_PERSONAL: 406,
  RCBC_PERSONAL: 409,
  SHOPEE_PERSONAL: 24,
  SCB_PERSONAL: 768,
  TOKOPEDIA_PERSONAL: 23,
  UNIONBANK_PERSONAL: 407,
  UNIONBANK_CORPORATE: 410,
  VCB_PERSONAL: 427
};

/**
 * @enum {number}
 */
proto.identity.TutorialStepStatus = {
  UNKNOWN_TUTORIALSTEPSTATUS: 0,
  DONE: 1,
  NOT_DONE: 2
};

/**
 * @enum {number}
 */
proto.identity.Agreement = {
  UNKNOWN_AGREEMENT: 0,
  ALL: 1,
  NONE: 2,
  BANK_INDONESIA_EXCLUSIVE: 3,
  SG_EXCLUSIVE: 4,
  SG_LEGACY: 5
};

goog.object.extend(exports, proto.identity);
